<template>
  <section class="content1">
    <!-- <loading :active.sync="isLoading"
      :can-cancel="true"
      color="#5bad2b"
      :is-full-page="fullPage"></loading> -->
    <!-- Default box -->
    <div class="row">
      <div class="col-md-4 download-pdf">
      <button class="btn btn-success btn-block" id="download" @click="generatePDF()">Download PDF</button>

      </div>
    </div>
    <div class="box">
      <!-- <div class="box-header with-border">
        <h3 class="box-title">Settings</h3>
      </div> -->
      <div class="box-body" style="height: 100%;min-height: 700px;">
        <!-- start tab -->
        <div class="row tc mt-5" v-if="feedbackdone">
          <h3>Already given the Feedback</h3>
        </div>
        <div class="row" id="pdfdocument" v-if="feedbacknotdone">
              <!-- <div class="col-sm-12">
                <img style="width: 15%; float:left;" class="mt-2" :src="postDetails.org_logo">
                <img style="width: 30%; float:right;" class="mt-2" src="../../assets/img/logo-black.png">
              </div> -->
              <div class="col-sm-12">
                <div>
                  <div class="box-header with-border mt-10" style="padding: 11px;text-align: center;font-size: 16px;">
                    <h4 v-if="interview_type=='Tech'" class="box-title"><b>INTERVIEW EVALUATION SHEET</b></h4><br>
                    <h4 v-if="interview_type=='HR'" class="box-title"><b>HR INTERVIEW EVALUATION SHEET</b></h4><br>
                    <h4 class="box-title">{{scheduleDetails.post_id == null ? scheduleDetails.candidate.designation : postDetails.job_title}}</h4><br>
                    <h4 v-if="interview_type=='Tech'" class="box-title">Interview Evaluation Form</h4>
                    <h4 v-if="interview_type=='HR'" class="box-title">HR Interview Evaluation Form</h4>
                  </div>
                  <div v-if="view=='mobile'">
                    <table class="table">
                        <tbody>
                          <tr>
                            <td style="width: 30%"><label>Candidate Name</label></td>
                            <td>
                              {{scheduleDetails.candidate.first_name}} {{ scheduleDetails.candidate.last_name == null ? '' : scheduleDetails.candidate.last_name}}
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 30%">
                              <label>Candidate Email Id</label>
                            </td>
                            <td>{{scheduleDetails.candidate.email}}</td>
                          </tr>
                          <tr>
                            <td style="width: 30%">
                              <label>Interviewer Name</label>
                            </td>
                            <td style="overflow-wrap: anywhere;">{{scheduleDetails.interviewer.candidate.first_name}} {{scheduleDetails.interviewer.candidate.last_name == null ? '' :scheduleDetails.interviewer.candidate.last_name}}</td>
                          </tr>
                          <tr>
                            <td style="width: 30%">
                              <label>Interview Date</label>
                            </td>
                            <td style="overflow-wrap: anywhere;">{{getDate(scheduleDetails.utc_starttime)}}</td>
                          </tr>
                          <tr>
                            <td style="width: 30%">
                              <label>Job Title</label>
                            </td>
                            <td style="overflow-wrap: anywhere;">{{scheduleDetails.post_id == null ? scheduleDetails.candidate.designation : postDetails.job_title}}</td>
                          </tr>
                          <tr>
                            <td style="width: 30%">
                              <label>Interview Time</label>
                            </td>
                            <td style="overflow-wrap: anywhere;">{{getTime(scheduleDetails.utc_starttime)}} - {{getEndTime(scheduleDetails.utc_starttime)}}</td>
                          </tr>
                          <tr>
                            <td style="width: 30%">
                              <label>Mode of Interview</label>
                            </td>
                            <td style="overflow-wrap: anywhere;">{{'Video'}}</td>
                          </tr>
                        </tbody>
                    </table>
                  </div>
                  <div v-if="view=='web'" class="box-header with-border" style="background-color: #f1f1f1;">
                    <div class="row">
                        <div class="col-md-6  p-5">
                          <span class="direct-chat-timestamp col-md-6">Candidate Name</span>
                          <span class="direct-chat-name col-md-6">{{scheduleDetails.candidate.first_name}} {{ scheduleDetails.candidate.last_name == null ? '' : scheduleDetails.candidate.last_name}}</span>
                        </div>
                        <div class="col-md-6  p-5">
                          <span class="direct-chat-timestamp col-md-6">Candidate Email Id</span>
                          <span class="direct-chat-name col-md-6">{{scheduleDetails.candidate.email}}</span>
                        </div>
                    </div>
                    <div class="row ">
                          <div class="col-md-6 p-5">
                            <span class="direct-chat-timestamp col-md-6">Interviewer Name</span>
                            <span class="direct-chat-name col-md-6">{{scheduleDetails.interviewer.candidate.first_name}} {{scheduleDetails.interviewer.candidate.last_name == null ? '' :scheduleDetails.interviewer.candidate.last_name}}</span>
                          </div>
                          <div class="col-md-6 p-5">
                            <span class="direct-chat-timestamp col-md-6">Interview Date</span>
                            <!-- <span class="direct-chat-name col-md-6">{{scheduleDetails.schedule_date | formatDate}}</span> -->
                            <span class="direct-chat-name col-md-6">{{getDate(scheduleDetails.utc_starttime)}}</span>
                          </div>
                    </div>
                    <div class="row">
                          <div class="col-md-6 p-5">
                            <span class="direct-chat-timestamp col-md-6">Job Title</span>
                            <span class="direct-chat-name col-md-6">{{scheduleDetails.post_id == null ? scheduleDetails.candidate.designation : postDetails.job_title}}</span>
                          </div>
                          <div class="col-md-6 p-5">
                          <span class="direct-chat-timestamp col-md-6">Interview Time</span>
                          <!-- <span class="direct-chat-name col-md-6">{{scheduleDetails.schedule_start_time}} to {{scheduleDetails.schedule_end_time}}</span> -->
                          <span class="direct-chat-name col-md-6">{{getTime(scheduleDetails.utc_starttime)}} - {{getEndTime(scheduleDetails.utc_starttime)}}</span>
                          </div>
                    </div>
                    <div class="row">
                          <div class="col-md-6 p-5">
                            <span class="direct-chat-timestamp col-md-6">Mode of Interview</span>
                            <span class="direct-chat-name col-md-6">{{'Video'}}</span>
                          </div>
                          <!-- <div class="col-md-6">
                            <span class="direct-chat-timestamp col-md-6">Interview Duration</span>
                            <span class="direct-chat-name col-md-6">{{scheduleDetails.interview_duration}}</span>
                          </div> -->
                    </div>
                  </div>
                  <b-form class="register-form" id="resets" v-on:submit.prevent="onSubmitFeedback" novalidate>
                    <div class="col-md-12">
                      <!-- <div class="form-row">
                          <div class="form-group">
                            <label>Client</label>
                              <div class="form-select">
                                <b-form-input style="height: 40px !important" v-model.lazy.trim="$v.form.client_name.$model" type="text" placeholder="Client Name"/>
                              </div>
                          </div>
                      </div> -->
                      <div class="form-row mt-2">
                          <p><br></p>
                          <div class="form-group">
                            <u><b>Candidate No Show</b></u>
                            <p style="margin: 0 0 -10px">&nbsp;</p>
                            <label class="container" style="width: 10% !important;padding-right: 40px;display: inline-block;"> Yes<input disabled  :checked="candidateshow == 'Yes'" type="radio" name="candidateshowVal" @change="onChangecandidate('Yes')" value="Yes" style="width: 10%;">
                          <span class="checkmark"></span>
                          </label>
                            <label class="container" style="width: 10% !important;display: inline-block;">No<input disabled  :checked="candidateshow == 'No'" type="radio" name="candidateshowVal" @change="onChangecandidate('No')" value="No" style="width: 10%;">
                            <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="form-group">
                            <u><b>Candidate Proxy</b></u>
                            <p style="margin: 0 0 -10px">&nbsp;</p>
                            <label class="container" style="width: 10% !important;padding-right: 40px;display: inline-block;"> Yes<input disabled  :checked="proxyVal == 'Yes'" type="radio" name="radio1" @change="onChangeproxy('Yes')" value="Yes" style="width: 10%;">
                          <span class="checkmark"></span>
                          </label>
                            <label class="container" style="width: 10% !important;display: inline-block;">No<input disabled  :checked="proxyVal == 'No'" type="radio" name="radio1" @change="onChangeproxy('No')" value="No" style="width: 10%;">
                            <span class="checkmark"></span>
                            </label>
                          </div>
                      </div>
                      <div class="form-row">
                          <div class="form-group" v-bind:class="{ 'disabled-div': dis_class }">
                            <label>Interview Status</label>
                              <div class="form-select">
                                <span style="color:green;" v-if="form.interview_status === 'Completed'"><b>{{form.interview_status}}</b></span>
                                <span style="color:red" v-if="form.interview_status !== 'Completed'"><b>{{form.interview_status}}</b></span>
                              </div>
                          </div>
                      </div>
                    </div>
                    <div class="col-md-12" v-if="showincomplete">
                      <div class="form-row" v-if="reason != null">
                          <div class="form-group" v-bind:class="{ 'disabled-div': dis_class }">
                            <!-- <div>reason {{reason}}</div> -->
                            <label>Reason</label>
                              <div class="form-select">
                                <select disabled id="level" v-model="reason" class="form-control">
                                  <option value=''>Select Reason *</option>
                                  <option v-for="(column, index) in reasonList" :key="index" :value="column.id"> {{column.name}}</option>
                               </select>
                                <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                                 <div v-if="reason_required">
                                  <p class="login-alert-msg error-content">* Select reason</p>
                                </div>
                              </div>
                          </div>
                      </div>
                      <label>Comments</label>
                      <b-form-textarea disabled v-model.lazy.trim="reason_comment" class="textarea" rows="1" placeholder="Enter your comments"></b-form-textarea>
                      <p v-if="reason_comment_required" class="login-alert-msg error-content">* Enter comments</p>
                      <br><br>
                      <div class="box-body" id="html-template">
                        <!-- start tab -->
                        <div class="col-md-6" v-if="view!='web'">
                          <!-- <p class="text-muted" style="text-align: center;">Rate this Interview</p> -->
                          <!-- :width="900" :height="450" -->
                          <hls-player :height="200" :autoplay="false" :muted="true" :controls="true" ref="myPlayer" :source="schedulevideo"/>
                        </div>
                        <div class="col-md-12" v-if="view=='web'">
                          <!-- <p class="text-muted" style="text-align: center;">Rate this Interview</p> -->
                          <!-- :width="900" :height="450" -->
                          <hls-player :height="450" :autoplay="false" :muted="true" :controls="true" ref="myPlayer" :source="schedulevideo"/>
                        </div>
                      </div>
                    </div>
                    <div v-if="interview_type=='Tech'">
                    <div v-if="showcomplete">
                    <div class="col-md-12">
                        <h4><u><b>Technical Evaluation</b></u></h4>
                        <p><b>Please evaluate the candidate on the following on a scale of 1 to 5 (1 Lowest, 5 highest)</b></p>
                        <h5><u><b>Skill Details</b></u></h5>
                    </div>
                    <div class="col-md-12 mb-2" style="background-color: #cccccc1f;" v-bind:class="{ 'disabled-div': dis_class }" v-for="(column, index) in tskills" :key="index">
                      <h5><strong>{{column.skill_name}}</strong></h5>
                      <table class="table">
                        <tbody>
                          <tr>
                            <td style="width: 30%"><label>Rating</label></td>
                            <td>
                              <star-rating :read-only="true" :show-rating="false" active-color="#5bad2b" v-model.lazy.trim="column.skill_rating" v-bind:star-size="20" ></star-rating>
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 30%">
                              <label>Experience</label>
                            </td>
                            <td>{{column.experience}}</td>
                          </tr>
                          <tr>
                            <td style="width: 30%">
                              <label>Technical Concepts</label>
                            </td>
                            <td style="overflow-wrap: anywhere;">{{column.program_concept}}</td>
                          </tr>
                          <tr>
                            <td style="width: 30%">
                              <label>Logic</label>
                            </td>
                            <td style="overflow-wrap: anywhere;">{{column.logics}}</td>
                          </tr>
                          <tr>
                            <td style="width: 30%">
                              <label>Development Tools</label>
                            </td>
                            <td style="overflow-wrap: anywhere;">{{column.development_tools}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-md-12" v-bind:class="{ 'disabled-div': dis_class }">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th>Non-Technical Evaluation</th>
                            <th>Rating</th>
                            <!-- <th>Comments</th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Communication Level</td>
                            <td><star-rating :read-only="true" v-model="commun_rating" @rating-selected="setRating($event, 'commun_rating')" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                            <!-- <td><b-form-textarea  v-model.lazy.trim="$v.form.commun_comments.$model" :state="chkState('commun_comments')" class="textarea" rows="1" placeholder="Enter comments"></b-form-textarea>
                            <div v-if="this.commun_error">
                                <p v-if="!$v.form.commun_comments.required" class="login-alert-msg error-content">* Enter Comments</p>
                              </div></td> -->
                          </tr>
                          <tr>
                            <td>Attention to Details</td>
                            <td><star-rating :read-only="true" v-model="attention_rating" @rating-selected="setRating($event, 'attention_rating')" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                            <!-- <td><b-form-textarea v-model.lazy.trim="$v.form.attention_comments.$model" :state="chkState('attention_comments')" class="textarea" rows="1" placeholder="Enter comments"></b-form-textarea>
                            <div v-if="this.attention_error">
                                <p v-if="!$v.form.attention_comments.required" class="login-alert-msg error-content">* Enter Comments</p>
                              </div></td> -->
                          </tr>
                          <tr>
                            <td>Integrity</td>
                            <td><star-rating :read-only="true" v-model="integrity_rating" @rating-selected="setRating($event, 'integrity_rating')" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                            <!-- <td><b-form-textarea  v-model.lazy.trim="$v.form.integrity_comments.$model" :state="chkState('integrity_comments')" class="textarea" rows="1" placeholder="Enter comments"></b-form-textarea>
                            <div v-if="this.integrity_error">
                              <p v-if="!$v.form.integrity_comments.required" class="login-alert-msg error-content">* Enter Comments</p>
                            </div></td> -->
                          </tr>
                          <tr>
                            <td>Cooperation</td>
                            <td><star-rating :read-only="true" v-model="cooperation_rating" @rating-selected="setRating($event, 'cooperation_rating')" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                            <!-- <td><b-form-textarea  v-model.lazy.trim="$v.form.cooperation_comments.$model" :state="chkState('cooperation_comments')" class="textarea" rows="1" placeholder="Enter comments"></b-form-textarea>
                            <div v-if="this.cooperation_error">
                              <p v-if="!$v.form.cooperation_comments.required" class="login-alert-msg error-content">* Enter Comments</p>
                            </div></td> -->
                          </tr>
                          <tr>
                            <td>Stress Tolerance</td>
                            <td><star-rating :read-only="true" v-model="stress_rating" @rating-selected="setRating($event, 'stress_rating')" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                            <!-- <td><b-form-textarea  v-model.lazy.trim="$v.form.stress_comments.$model" :state="chkState('stress_comments')" class="textarea" rows="1" placeholder="Enter comments"></b-form-textarea>
                            <div v-if="this.stress_error">
                              <p v-if="!$v.form.stress_comments.required" class="login-alert-msg error-content">* Enter Comments</p>
                            </div></td> -->
                          </tr>
                          <tr>
                            <td>Learning Ability</td>
                            <td><star-rating :read-only="true" v-model="learning_rating" @rating-selected="setRating($event, 'learning_rating')" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                            <!-- <td><b-form-textarea  v-model.lazy.trim="$v.form.learning_comments.$model" :state="chkState('learning_comments')" class="textarea" rows="1" placeholder="Enter comments"></b-form-textarea>
                            <div v-if="this.learning_error">
                              <p v-if="!$v.form.learning_comments.required" class="login-alert-msg error-content">* Enter Comments</p>
                            </div></td> -->
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-md-12" v-bind:class="{ 'disabled-div': dis_class }">
                      <u><b>Others</b></u>
                      <table class="table table-bordered mt-2">
                        <tbody>
                          <tr>
                            <td>Window Violation - <b><span v-if="window_violation">Yes</span><span v-if="!window_violation">No</span></b></td>
                            <td  class="sitscclass">
                              <b-form-textarea  disabled v-model.lazy.trim="$v.form.window_violation_comments.$model" :state="chkState('window_violation')" class="textarea" rows="1" placeholder="Enter comments">
                              </b-form-textarea>
                              <div v-if="this.clientError">
                                <p v-if="!$v.form.window_violation.required" class="login-alert-msg error-content">* Enter Comments</p>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td><b>Final Recommendation</b></td>
                            <td  class="sitscclass"></td>
                          </tr>
                          <!-- <tr>
                            <td><div class="form-group">
                            <u><b>Recommended?</b></u>
                            <p>&nbsp;</p>
                            <label class="container" style="width: 10% !important;padding-right: 40px;display: inline-block;"> Yes<input :checked="recommendedVal == 'Yes'" type="radio" name="recommended" @change="onChangerecommended('Yes')" value="Yes" style="width: 10%;">
                          <span class="checkmark"></span>
                          </label>
                            <label class="container" style="width: 10% !important;display: inline-block;">No<input :checked="recommendedVal == 'No'" type="radio" name="recommended" @change="onChangerecommended('No')" value="No" style="width: 10%;">
                            <span class="checkmark"></span>
                            </label>
                          </div></td>
                          </tr> -->
                          <tr>
                            <td>Interviewer Comments:</td>
                            <td  class="sitscclass">
                              <b-form-textarea disabled v-model.lazy.trim="$v.form.interviewer_comments.$model" :state="chkState('interviewer_comments')" class="textarea" rows="1" placeholder="Enter comments"></b-form-textarea>
                              <div v-if="this.clientError">
                                <p v-if="!$v.form.interviewer_comments.required" class="login-alert-msg error-content">* Enter Comments</p>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>Screenit Score</td>
                            <td  class="sitscclass">
                              <div>
                                <span v-for="item in 10" :key="item" v-bind:class="{'sit-score-active': item == sit_score || item < sit_score}" class="sit-score">{{item}}</span>
                              </div>
                              <div v-if="this.clientError">
                                <p v-if="!$v.form.screenit_score.required" class="login-alert-msg error-content">* Enter Comments</p>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>Recommended1</td>
                            <td  class="sitscclass">{{recommended}}</td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="box-body" id="html-template">
                        <!-- start tab -->
                        <div class="col-md-6" v-if="view!='web'">
                          <!-- <p class="text-muted" style="text-align: center;">Rate this Interview</p> -->
                          <!-- :width="900" :height="450" -->
                          <hls-player :height="200" :autoplay="false" :muted="true" :controls="true" ref="myPlayer" :source="schedulevideo"/>
                        </div>
                        <div class="col-md-12" v-if="view=='web'">
                          <!-- <p class="text-muted" style="text-align: center;">Rate this Interview</p> -->
                          <!-- :width="900" :height="450" -->
                          <hls-player :height="450" :autoplay="false" :muted="true" :controls="true" ref="myPlayer" :source="schedulevideo"/>
                        </div>
                      </div>
                      <br><br>
                      <!-- chat -->
                      <!-- <div class="col-md-12" v-if="interviewChats.length > 0">
                        <div><strong>Chat</strong></div>
                      </div>
                      <div class="col-md-12" style="max-height:250px; overflow: auto; background-color: #f2f2f269;" v-if="interviewChats.length > 0">
                        <div v-for="chat in interviewChats" :key="chat.id">
                          <div class="intchatbox">
                            <div>
                              <strong>
                                <span v-if="chat.role =='1'">{{ orgName }}</span>
                                <span v-else-if="chat.role =='2'">{{ intName }}</span>
                                <span v-else-if="chat.role =='3'">{{ canName }}</span>
                              </strong> &nbsp;&nbsp;
                              <span style="color: #5a5a5a69; font-size: 13;">{{getTime(chat.time)}}</span>
                            </div>
                            {{ chat.msg }}
                            <div class="roleClass">
                              <span class="roleClassIn" style="background-color: blue" v-if="chat.role =='1'">Organization</span>
                              <span class="roleClassIn" style="background-color: #5bad2b" v-else-if="chat.role =='2'">Interviewer</span>
                              <span class="roleClassIn" style="background-color: red" v-else-if="chat.role =='3'">Candidate</span>
                            </div>
                          </div>
                        </div>
                      </div> -->
                      <div class="col-md-12" style="padding: 15px" v-if="schedule_codes.length > 0">
                      <div class="form-row" style="background-color: #cccccc69;padding: 7px;">
                        <label>Candidate's Programming Code</label>
                      </div>
                    </div>
                    <div class="col-md-12" style="padding: 16px" v-for="v in schedule_codes" :key="v">
                      <div class="form-row">
                        <label>Tittle: {{v.title}}</label>
                      </div>
                      <div class="form-row">
                         <VueCodeEditor
                          :value="v.code"
                          @init="editorInit"
                          lang="javascript"
                          theme="monokai"
                          width="100%"
                          height="200px"
                          :options="{
                            enableBasicAutocompletion: true,
                            enableLiveAutocompletion: true,
                            fontSize: 14,
                            highlightActiveLine: true,
                            enableSnippets: true,
                            showLineNumbers: true,
                            tabSize: 2,
                            showPrintMargin: true,
                            showGutter: true,
                          }"
                          :commands="[
                              {
                                name: 'save',
                                bindKey: { win: 'Ctrl-s', mac: 'Command-s' },
                                exec: null,
                                readOnly: true,
                              },
                          ]"
                          />
                      </div>
                    </div>
                    </div>
                    <br>
                    <br>
                    </div>
                    </div>
                    <div v-if="interview_type=='HR'">
                      <div v-if="showcomplete">
                        <div class="col-md-12 mb-2" style="background-color: #cccccc1f;" v-bind:class="{ 'disabled-div': dis_class }">
                          <table class="table table-bordered">
                            <thead>
                              <tr>
                                <th>Question</th>
                                <th>Rating Scale</th>
                                <th>Comments</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <div class="justify-td">
                                    <span>Did the candidate have the necessary qualifications and experience for the role?</span>
                                    <span >
                                      <i id="popover-target-1" style="color:#1163e6; text-shadow: 0px 2px 3px #a39f9f; font-size: 16px;" class="fa fa-question-circle" aria-hidden="true"></i>
                                      <b-popover target="popover-target-1" triggers="hover" placement="top">
                                        <div style="padding: 10px">
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Education and certifications</div>
                                          <div style="color:grey; font-size: 12px;">This metric evaluates the candidate's educational background and professional certifications. It can help you determine if they have the necessary academic qualifications for the role.</div>
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Work experience</div>
                                          <div style="color:grey; font-size: 12px;">This metric assesses the candidate's previous work experience, including the number of years they have worked in a similar role, the level of responsibility they have held, and the industries they have worked in. This can help you determine if they have the relevant experience to perform well in the role</div>
                                        </div>
                                      </b-popover>
                                    </span>
                                  </div>
                                </td>
                                <td><star-rating v-model="qualification" :read-only="true" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                                <td>
                                  {{qualification_cmd}}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div class="justify-td">
                                    <span>How well did the candidate demonstrate their problem solving skills and abilities during the interview?</span>
                                    <span >
                                      <i id="popover-target-2" style="color:#1163e6; text-shadow: 0px 2px 3px #a39f9f; font-size: 16px;" class="fa fa-question-circle" aria-hidden="true"></i>
                                      <b-popover target="popover-target-2" triggers="hover" placement="top">
                                        <div style="padding: 10px">
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Approach to problem-solving</div>
                                          <div style="color:grey; font-size: 12px;">This metric evaluates the candidate's approach to solving a problem. It can help you determine if they can break down complex problems into smaller parts and approach them systematically</div>
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Creativity and innovation</div>
                                          <div style="color:grey; font-size: 12px;">This metric evaluates the candidate's ability to come up with creative and innovative solutions to problems. It can help you determine if they can think outside the box and come up with new and unique ideas</div>
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Decision-making</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who can make effective decisions under pressure demonstrate good decision-making skills</div>
                                        </div>
                                      </b-popover>
                                    </span>
                                  </div>
                                </td>
                                <td><star-rating v-model="problem_solving" :read-only="true" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                                <td>
                                  {{problem_solving_cmd}}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div class="justify-td">
                                    <span>How well the candidate exhibit professionalism?</span>
                                    <span >
                                      <i id="popover-target-3" style="color:#1163e6; text-shadow: 0px 2px 3px #a39f9f; font-size: 16px;" class="fa fa-question-circle" aria-hidden="true"></i>
                                      <b-popover target="popover-target-3" triggers="hover" placement="top">
                                        <div style="padding: 10px">
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Appearance</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who present themselves in a professional and appropriate manner, including their dress, grooming, and body language, demonstrate professionalism. This metric can help you assess the candidate's attention to detail and their ability to represent the company well.</div>
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Punctuality and reliability</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who arrive on time for the interview, respond promptly to emails and calls, and follow through on commitments demonstrate punctuality and reliability. This metric can help you assess the candidate's dependability and work ethic.</div>
                                        </div>
                                      </b-popover>
                                    </span>
                                  </div>
                                </td>
                                <td><star-rating v-model="professionalism" :read-only="true" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                                <td>
                                  {{professionalism_cmd}}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div class="justify-td">
                                    <span>Did the candidate exhibit a positive attitude and confidence throughout the interview?</span>
                                    <span >
                                      <i id="popover-target-4" style="color:#1163e6; text-shadow: 0px 2px 3px #a39f9f; font-size: 16px;" class="fa fa-question-circle" aria-hidden="true"></i>
                                      <b-popover target="popover-target-4" triggers="hover" placement="top">
                                        <div style="padding: 10px">
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Enthusiasm</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who display enthusiasm and excitement about the role and the company demonstrate a positive attitude. This metric can help you assess the candidate's level of interest and engagement in the position.</div>
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Confidence</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who display confidence in their abilities, experience, and responses demonstrate confidence. This metric can help you assess the candidate's self-assurance and assertiveness.</div>
                                        </div>
                                      </b-popover>
                                    </span>
                                  </div>
                                </td>
                                <td><star-rating v-model="attitude_confidence" :read-only="true" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                                <td>
                                  {{ attitude_confidence_cmd }}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div class="justify-td">
                                    <span>How well did the candidate demonstrate their communication skills ?</span>
                                    <span >
                                      <i id="popover-target-5" style="color:#1163e6; text-shadow: 0px 2px 3px #a39f9f; font-size: 16px;" class="fa fa-question-circle" aria-hidden="true"></i>
                                      <b-popover target="popover-target-5" triggers="hover" placement="top">
                                        <div style="padding: 10px">
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Clarity</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who communicate clearly and concisely, using appropriate language and tone, demonstrate good communication skills. This metric can help you assess the candidate's ability to convey information effectively.</div>
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Nonverbal communication</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who use appropriate nonverbal cues, including eye contact, facial expressions, and body language, demonstrate good communication skills. This metric can help you assess the candidate's ability to communicate effectively and build rapport with others.</div>
                                        </div>
                                      </b-popover>
                                    </span>
                                  </div>
                                </td>
                                <td><star-rating v-model="communication_skill" :read-only="true" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                                <td>
                                  {{ communication_skill_cmd }}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div class="justify-td">
                                    <span>How well did the candidate demonstrate their interpersonal skills ?</span>
                                    <span >
                                      <i id="popover-target-6" style="color:#1163e6; text-shadow: 0px 2px 3px #a39f9f; font-size: 16px;" class="fa fa-question-circle" aria-hidden="true"></i>
                                      <b-popover target="popover-target-6" triggers="hover" placement="top">
                                        <div style="padding: 10px">
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Empathy</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who demonstrate empathy, including the ability to understand and share the feelings of others, demonstrate good interpersonal skills. This metric can help you assess the candidate's ability to relate to and connect with team members, customers, and stakeholders.</div>
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Conflict resolution</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who demonstrate the ability to resolve conflicts and disagreements constructively and diplomatically demonstrate good interpersonal skills. This metric can help you assess the candidate's ability to handle challenging situations and work effectively with others.</div>
                                        </div>
                                      </b-popover>
                                    </span>
                                  </div>
                                </td>
                                <td><star-rating v-model="inter_personal_skill" :read-only="true" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                                <td>
                                  {{inter_personal_skill}}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div class="justify-td">
                                    <span>Did the candidate express interest in potential opportunities for growth and development within the company?</span>
                                    <span >
                                      <i id="popover-target-7" style="color:#1163e6; text-shadow: 0px 2px 3px #a39f9f; font-size: 16px;" class="fa fa-question-circle" aria-hidden="true"></i>
                                      <b-popover target="popover-target-7" triggers="hover" placement="top">
                                        <div style="padding: 10px">
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Career goals</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who express clear career goals and aspirations, and who demonstrate a desire to grow and develop within the company, demonstrate an interest in potential opportunities for growth and development. This metric can help you assess the candidate's level of ambition and motivation.</div>
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Job satisfaction</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who express satisfaction with the job and the company, and who indicate a desire to grow and develop within their role, demonstrate an interest in potential opportunities for growth and development. This metric can help you assess the candidate's level of engagement and motivation.</div>
                                        </div>
                                      </b-popover>
                                    </span>
                                  </div>
                                </td>
                                <td><star-rating v-model="growth_development" :read-only="true" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                                <td>
                                  {{growth_development_cmd}}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div class="justify-td">
                                    <span>How well did the candidate answer team work related Questions?</span>
                                    <span >
                                      <i id="popover-target-8" style="color:#1163e6; text-shadow: 0px 2px 3px #a39f9f; font-size: 16px;" class="fa fa-question-circle" aria-hidden="true"></i>
                                      <b-popover target="popover-target-8" triggers="hover" placement="top">
                                        <div style="padding: 10px">
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Collaboration</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who demonstrate an understanding of the importance of collaboration in achieving team goals, and who provide examples of successful collaboration experiences, demonstrate good teamwork skills. This metric can help you assess the candidate's ability to work effectively with others.</div>
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Adaptability</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who demonstrate an ability to adapt to changing circumstances within a team, and who provide examples of how they have successfully navigated such changes, demonstrate good teamwork skills. This metric can help you assess the candidate's ability to work effectively in a dynamic team environment.</div>
                                        </div>
                                      </b-popover>
                                    </span>
                                  </div>
                                </td>
                                <td><star-rating v-model="team_work" :read-only="true" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                                <td>
                                  {{team_work_cmd}}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div class="justify-td">
                                    <span>How was the candidate’s responsiveness to change, and tolerance?</span>
                                    <span >
                                      <i id="popover-target-9" style="color:#1163e6; text-shadow: 0px 2px 3px #a39f9f; font-size: 16px;" class="fa fa-question-circle" aria-hidden="true"></i>
                                      <b-popover target="popover-target-9" triggers="hover" placement="top">
                                        <div style="padding: 10px">
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Tolerance for ambiguity</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who demonstrate a willingness to work in situations with unclear or uncertain outcomes, and who provide examples of how they have successfully managed ambiguity in their previous roles, demonstrate good tolerance for ambiguity. This metric can help you assess the candidate's ability to work effectively in complex and uncertain environments.</div>
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Flexibility</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who demonstrate an ability to be flexible and to adjust their approach or methods as needed, and who provide examples of how they have successfully done so in their previous roles, demonstrate good responsiveness to change. This metric can help you assess the candidate's ability to work effectively in a fast-paced and changing work environment.</div>
                                        </div>
                                      </b-popover>
                                    </span>
                                  </div>
                                </td>
                                <td><star-rating v-model="stress_tolerance" :read-only="true" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                                <td>
                                  {{stress_tolerance_cmd}}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div class="justify-td">
                                    <span>How potential is the candidate to fit the Organization’s culture?</span>
                                    <span >
                                      <i id="popover-target-10" style="color:#1163e6; text-shadow: 0px 2px 3px #a39f9f; font-size: 16px;" class="fa fa-question-circle" aria-hidden="true"></i>
                                      <b-popover target="popover-target-10" triggers="hover" placement="top">
                                        <div style="padding: 10px">
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Values Alignment</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who demonstrate an understanding of the organization's values and mission, and who share those values, are more likely to fit well within the organization's culture. This metric can help you assess the candidate's values and their potential to align with the organization's culture.</div>
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Cultural Fit</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who demonstrate an understanding of the organization's culture and who can provide examples of how they have successfully adapted to a similar culture in the past, are more likely to fit well within the organization's culture. This metric can help you assess the candidate's ability to work effectively within the organization's culture.</div>
                                        </div>
                                      </b-popover>
                                    </span>
                                  </div>
                                </td>
                                <td><star-rating v-model="org_culture" :read-only="true" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                                <td>
                                  {{org_culture_cmd}}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="col-md-12" v-bind:class="{ 'disabled-div': dis_class }">
                          <u><b>Others</b></u>
                          <table class="table table-bordered mt-2">
                            <tbody>
                              <tr>
                                <td>Window Violation - <b><span v-if="window_violation">Yes</span><span v-if="!window_violation">No</span></b></td>
                                <td  class="sitscclass">
                                  <b-form-textarea  disabled v-model.lazy.trim="$v.form.window_violation_comments.$model" :state="chkState('window_violation')" class="textarea" rows="1" placeholder="Enter comments">
                                  </b-form-textarea>
                                  <div v-if="this.clientError">
                                    <p v-if="!$v.form.window_violation.required" class="login-alert-msg error-content">* Enter Comments</p>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td><b>Final Recommendation</b></td>
                                <td  class="sitscclass"></td>
                              </tr>
                              <tr>
                                <td>Interviewer Comments:</td>
                                <td  class="sitscclass">
                                  <b-form-textarea disabled v-model.lazy.trim="$v.form.interviewer_comments.$model" :state="chkState('interviewer_comments')" class="textarea" rows="1" placeholder="Enter comments"></b-form-textarea>
                                  <div v-if="this.clientError">
                                    <p v-if="!$v.form.interviewer_comments.required" class="login-alert-msg error-content">* Enter Comments</p>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>Screenit Score</td>
                                <td  class="sitscclass">
                                  <div>
                                    <span v-for="item in 10" :key="item" v-bind:class="{'sit-score-active': item == sit_score || item < sit_score}" class="sit-score">{{item}}</span>
                                  </div>
                                  <div v-if="this.clientError">
                                    <p v-if="!$v.form.screenit_score.required" class="login-alert-msg error-content">* Enter Comments</p>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>Recommended</td>
                                <td  class="sitscclass">{{recommended}}</td>
                              </tr>
                            </tbody>
                          </table>
                          <div class="box-body" id="html-template">
                            <!-- start tab -->
                            <div class="col-md-6" v-if="view!='web'">
                              <!-- <p class="text-muted" style="text-align: center;">Rate this Interview</p> -->
                              <!-- :width="900" :height="450" -->
                              <hls-player :height="200" :autoplay="false" :muted="true" :controls="true" ref="myPlayer" :source="schedulevideo"/>
                            </div>
                            <div class="col-md-12" v-if="view=='web'">
                              <!-- <p class="text-muted" style="text-align: center;">Rate this Interview</p> -->
                              <!-- :width="900" :height="450" -->
                              <hls-player :height="450" :autoplay="false" :muted="true" :controls="true" ref="myPlayer" :source="schedulevideo"/>
                            </div>
                          </div>
                          <br><br>
                          <!-- chat -->
                          <!-- <div class="col-md-12" v-if="interviewChats.length > 0">
                            <div><strong>Chat</strong></div>
                          </div>
                          <div class="col-md-12" style="max-height:250px; overflow: auto; background-color: #f2f2f269;" v-if="interviewChats.length > 0">
                            <div v-for="chat in interviewChats" :key="chat.id">
                              <div class="intchatbox">
                                <div>
                                  <strong>
                                    <span v-if="chat.role =='1'">{{ orgName }}</span>
                                    <span v-else-if="chat.role =='2'">{{ intName }}</span>
                                    <span v-else-if="chat.role =='3'">{{ canName }}</span>
                                  </strong> &nbsp;&nbsp;
                                  <span style="color: #5a5a5a69; font-size: 13;">{{getTime(chat.time)}}</span>
                                </div>
                                {{ chat.msg }}
                                <div class="roleClass">
                                  <span class="roleClassIn" style="background-color: blue" v-if="chat.role =='1'">Organization</span>
                                  <span class="roleClassIn" style="background-color: #5bad2b" v-else-if="chat.role =='2'">Interviewer</span>
                                  <span class="roleClassIn" style="background-color: red" v-else-if="chat.role =='3'">Candidate</span>
                                </div>
                              </div>
                            </div>
                          </div> -->
                          <div class="col-md-12" style="padding: 15px" v-if="schedule_codes.length > 0">
                            <div class="form-row" style="background-color: #cccccc69;padding: 7px;">
                              <label>Candidate's Programming Code</label>
                            </div>
                          </div>
                          <div class="col-md-12" style="padding: 16px" v-for="v in schedule_codes" :key="v">
                            <div class="form-row">
                              <label>Tittle: {{v.title}}</label>
                            </div>
                            <div class="form-row">
                              <VueCodeEditor
                                :value="v.code"
                                @init="editorInit"
                                lang="javascript"
                                theme="monokai"
                                width="100%"
                                height="200px"
                                :options="{
                                  enableBasicAutocompletion: true,
                                  enableLiveAutocompletion: true,
                                  fontSize: 14,
                                  highlightActiveLine: true,
                                  enableSnippets: true,
                                  showLineNumbers: true,
                                  tabSize: 2,
                                  showPrintMargin: true,
                                  showGutter: true,
                                }"
                                :commands="[
                                    {
                                      name: 'save',
                                      bindKey: { win: 'Ctrl-s', mac: 'Command-s' },
                                      exec: null,
                                      readOnly: true,
                                    },
                                ]"
                                />
                            </div>
                          </div>
                        </div>
                        <br>
                        <br>
                      </div>
                    </div>
                    <br><br>
                    <div class="col-md-12"><p><br><br></p></div>
                    <div class="col-md-12" v-if="resume.length != 0">
                      Candidate Resume:
                      <a :href="resume[0].url" target="_blank" style="color:blue; text-decoration: underline;">Click here</a>
                    </div>
                 <div class="col-md-12"><p><br><br></p></div>
            </b-form>

                </div>
              </div>
            </div>
      </div>
        <!-- end tab -->
      <!-- /.box-body -->
    </div>
    <!-- /.box -->
    <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="true"
        filename="feedback"
        :pdf-quality="2"
        :manual-pagination="true"
        pdf-format="a4"
        @progress="onProgress($event)"
        @hasStartedGeneration="hasStartedGeneration()"
        @hasGenerated="hasGenerated($event)"
        ref="html2Pdf">
        <section slot="pdf-content">
            <div class="row" id="pdfdocument" v-if="feedbacknotdone">
              <!-- <div class="col-sm-12">
                <img style="width: 15%; float:left;" class="mt-2" :src="postDetails.org_logo">
                <img style="width: 30%; float:right;" class="mt-2" src="../../assets/img/logo-black.png">
              </div> -->
              <div class="col-sm-12">
                  <div style="height: 60px;"><p></p></div>
                  <div class="box-header with-border mt-10" style="padding: 11px;text-align: center;font-size: 16px;">
                    <h4 v-if="interview_type=='Tech'" class="box-title"><b>INTERVIEW EVALUATION SHEET</b></h4><br>
                    <h4 v-if="interview_type=='HR'" class="box-title"><b>HR INTERVIEW EVALUATION SHEET</b></h4><br>
                    <h4 class="box-title">{{scheduleDetails.post_id == null ? scheduleDetails.candidate.designation : postDetails.job_title}}</h4><br>
                    <h4 v-if="interview_type=='Tech'" class="box-title">Interview Evaluation Form</h4>
                    <h4 v-if="interview_type=='HR'" class="box-title">HR Interview Evaluation Form</h4>
                  </div>
                  <div v-if="view=='mobile'">
                    <table class="table">
                        <tbody>
                          <tr>
                            <td style="width: 30%"><label>Candidate Name</label></td>
                            <td>
                              {{scheduleDetails.candidate.first_name}} {{ scheduleDetails.candidate.last_name == null ? '' : scheduleDetails.candidate.last_name}}
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 30%">
                              <label>Candidate Email Id</label>
                            </td>
                            <td>{{scheduleDetails.candidate.email}}</td>
                          </tr>
                          <tr>
                            <td style="width: 30%">
                              <label>Interviewer Name</label>
                            </td>
                            <td style="overflow-wrap: anywhere;">{{scheduleDetails.interviewer.candidate.first_name}} {{scheduleDetails.interviewer.candidate.last_name == null ? '' :scheduleDetails.interviewer.candidate.last_name}}</td>
                          </tr>
                          <tr>
                            <td style="width: 30%">
                              <label>Interview Date</label>
                            </td>
                            <td style="overflow-wrap: anywhere;">{{getDate(scheduleDetails.utc_starttime)}}</td>
                          </tr>
                          <tr>
                            <td style="width: 30%">
                              <label>Job Title</label>
                            </td>
                            <td style="overflow-wrap: anywhere;">{{scheduleDetails.post_id == null ? scheduleDetails.candidate.designation : postDetails.job_title}}</td>
                          </tr>
                          <tr>
                            <td style="width: 30%">
                              <label>Interview Time</label>
                            </td>
                            <td style="overflow-wrap: anywhere;">{{getTime(scheduleDetails.utc_starttime)}} - {{getEndTime(scheduleDetails.utc_starttime)}}</td>
                          </tr>
                          <tr>
                            <td style="width: 30%">
                              <label>Mode of Interview</label>
                            </td>
                            <td style="overflow-wrap: anywhere;">{{'Video'}}</td>
                          </tr>
                        </tbody>
                    </table>
                  </div>
                  <div v-if="view=='web'" class="box-header with-border" style="background-color: #f1f1f1;">
                    <div class="row">
                        <div class="col-md-6  p-5">
                          <span class="direct-chat-timestamp col-md-6">Candidate Name</span>
                          <span class="direct-chat-name col-md-6">{{scheduleDetails.candidate.first_name}} {{ scheduleDetails.candidate.last_name == null ? '' : scheduleDetails.candidate.last_name}}</span>
                        </div>
                        <div class="col-md-6  p-5">
                          <span class="direct-chat-timestamp col-md-6">Candidate Email Id</span>
                          <span class="direct-chat-name col-md-6">{{scheduleDetails.candidate.email}}</span>
                        </div>
                    </div>
                    <div class="row ">
                          <div class="col-md-6 p-5">
                            <span class="direct-chat-timestamp col-md-6">Interviewer Name</span>
                            <span class="direct-chat-name col-md-6">{{scheduleDetails.interviewer.candidate.first_name}} {{scheduleDetails.interviewer.candidate.last_name == null ? '' :scheduleDetails.interviewer.candidate.last_name}}</span>
                          </div>
                          <div class="col-md-6 p-5">
                            <span class="direct-chat-timestamp col-md-6">Interview Date</span>
                            <!-- <span class="direct-chat-name col-md-6">{{scheduleDetails.schedule_date | formatDate}}</span> -->
                            <span class="direct-chat-name col-md-6">{{getDate(scheduleDetails.utc_starttime)}}</span>
                          </div>
                    </div>
                    <div class="row">
                          <div class="col-md-6 p-5">
                            <span class="direct-chat-timestamp col-md-6">Job Title</span>
                            <span class="direct-chat-name col-md-6">{{scheduleDetails.post_id == null ? scheduleDetails.candidate.designation : postDetails.job_title}}</span>
                          </div>
                          <div class="col-md-6 p-5">
                          <span class="direct-chat-timestamp col-md-6">Interview Time</span>
                          <!-- <span class="direct-chat-name col-md-6">{{scheduleDetails.schedule_start_time}} to {{scheduleDetails.schedule_end_time}}</span> -->
                          <span class="direct-chat-name col-md-6">{{getTime(scheduleDetails.utc_starttime)}} - {{getEndTime(scheduleDetails.utc_starttime)}}</span>
                          </div>
                    </div>
                    <div class="row">
                          <div class="col-md-6 p-5">
                            <span class="direct-chat-timestamp col-md-6">Mode of Interview</span>
                            <span class="direct-chat-name col-md-6">{{'Video'}}</span>
                          </div>
                          <!-- <div class="col-md-6">
                            <span class="direct-chat-timestamp col-md-6">Interview Duration</span>
                            <span class="direct-chat-name col-md-6">{{scheduleDetails.interview_duration}}</span>
                          </div> -->
                    </div>
                  </div>
                    <div class="col-md-12">
                      <!-- <div class="form-row">
                          <div class="form-group">
                            <label>Client</label>
                              <div class="form-select">
                                <b-form-input style="height: 40px !important" v-model.lazy.trim="$v.form.client_name.$model" type="text" placeholder="Client Name"/>
                              </div>
                          </div>
                      </div> -->
                      <div class="form-row mt-2">
                          <p><br></p>
                          <div class="form-group">
                            <u><b>Candidate No Show</b></u>
                            <p style="margin: 0 0 -10px">&nbsp;</p>
                            <label class="container" style="width: 10% !important;padding-right: 40px;display: inline-block;"> Yes<input disabled  :checked="candidateshow == 'Yes'" type="radio" name="candidateshowVal" @change="onChangecandidate('Yes')" value="Yes" style="width: 10%;">
                          <span class="checkmark"></span>
                          </label>
                            <label class="container" style="width: 10% !important;display: inline-block;">No<input disabled  :checked="candidateshow == 'No'" type="radio" name="candidateshowVal" @change="onChangecandidate('No')" value="No" style="width: 10%;">
                            <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="form-group">
                            <u><b>Candidate Proxy</b></u>
                            <p style="margin: 0 0 -10px">&nbsp;</p>
                            <label class="container" style="width: 10% !important;padding-right: 40px;display: inline-block;"> Yes<input disabled  :checked="proxyVal == 'Yes'" type="radio" name="radio1" @change="onChangeproxy('Yes')" value="Yes" style="width: 10%;">
                          <span class="checkmark"></span>
                          </label>
                            <label class="container" style="width: 10% !important;display: inline-block;">No<input disabled  :checked="proxyVal == 'No'" type="radio" name="radio1" @change="onChangeproxy('No')" value="No" style="width: 10%;">
                            <span class="checkmark"></span>
                            </label>
                          </div>
                      </div>
                      <div class="form-row">
                          <div class="form-group" v-bind:class="{ 'disabled-div': dis_class }">
                            <label>Interview Status</label>
                              <div class="form-select">
                                <span style="color:green;" v-if="form.interview_status === 'Completed'"><b>{{form.interview_status}}</b></span>
                                <span style="color:red" v-if="form.interview_status !== 'Completed'"><b>{{form.interview_status}}</b></span>
                              </div>
                          </div>
                      </div>
                    </div>
                    <div class="col-md-12" v-if="showincomplete">
                      <div class="form-row" v-if="reason != null">
                          <div class="form-group" v-bind:class="{ 'disabled-div': dis_class }">
                            <label>Reason</label>
                              <div class="form-select">
                                <select disabled id="level" v-model="reason" class="form-control">
                                  <option value=''>Select Reason *</option>
                                  <option v-for="(column, index) in reasonList" :key="index" :value="column.id"> {{column.name}}</option>
                               </select>
                                <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                                 <div v-if="reason_required">
                                  <p class="login-alert-msg error-content">* Select reason</p>
                                </div>
                              </div>
                          </div>
                      </div>
                      <label>Comments</label>
                      <b-form-textarea disabled v-model.lazy.trim="reason_comment" class="textarea" rows="1" placeholder="Enter your comments"></b-form-textarea>
                      <p v-if="reason_comment_required" class="login-alert-msg error-content">* Enter comments</p>
                    </div>
                    <div v-if="interview_type=='Tech'">
                    <div v-if="showcomplete">
                    <div class="col-md-12">
                        <h4><u><b>Technical Evaluation</b></u></h4>
                        <p><b>Please evaluate the candidate on the following on a scale of 1 to 5 (1 Lowest, 5 highest)</b></p>
                        <h5><u><b>Skill Details</b></u></h5>
                    </div>
                    <div class="col-md-12 mb-2" style="background-color: #cccccc1f;" v-bind:class="{ 'disabled-div': dis_class }" v-for="(column, index) in tskills.slice(0, 1)" :key="index">
                      <h5><strong>{{column.skill_name}}</strong></h5>
                      <table class="table">
                        <tbody>
                          <tr>
                            <td style="width: 30%"><label>Rating</label></td>
                            <td>
                              <star-rating :read-only="true" :show-rating="false" active-color="#5bad2b" v-model.lazy.trim="column.skill_rating" v-bind:star-size="20" ></star-rating>
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 30%">
                              <label>Experience</label>
                            </td>
                            <td>{{column.experience}}</td>
                          </tr>
                          <tr>
                            <td style="width: 30%">
                              <label>Technical Concepts</label>
                            </td>
                            <td style="overflow-wrap: anywhere;">{{column.program_concept}}</td>
                          </tr>
                          <tr>
                            <td style="width: 30%">
                              <label>Logic</label>
                            </td>
                            <td style="overflow-wrap: anywhere;">{{column.logics}}</td>
                          </tr>
                          <tr>
                            <td style="width: 30%">
                              <label>Development Tools</label>
                            </td>
                            <td style="overflow-wrap: anywhere;">{{column.development_tools}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    </div>
                    <div v-if="showcomplete">
                    <div v-if="tskillsLength > 2" class="html2pdf__page-break"/>
                    <section class="row pdf-item" v-if="tskillsLength > 2">
                      <div style="height: 100px;"><p></p></div>
                      <div class="col-md-12 mb-2" style="background-color: #cccccc1f;" v-bind:class="{ 'disabled-div': dis_class }" v-for="(column, index) in tskills.slice(1, 3)" :key="index">
                        <h5><strong>{{column.skill_name}}</strong></h5>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td style="width: 30%"><label>Rating</label></td>
                              <td>
                                <star-rating :read-only="true" :show-rating="false" active-color="#5bad2b" v-model.lazy.trim="column.skill_rating" v-bind:star-size="20" ></star-rating>
                              </td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Experience</label>
                              </td>
                              <td>{{column.experience}}</td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Technical Concepts</label>
                              </td>
                              <td style="overflow-wrap: anywhere;">{{column.program_concept}}</td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Logic</label>
                              </td>
                              <td style="overflow-wrap: anywhere;">{{column.logics}}</td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Development Tools</label>
                              </td>
                              <td style="overflow-wrap: anywhere;">{{column.development_tools}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </section>
                    </div>
                    <div v-if="showcomplete">
                    <div v-if="tskillsLength > 3" class="html2pdf__page-break"/>
                    <section class="row pdf-item" v-if="tskillsLength > 3">
                      <div style="height: 100px;"><p></p></div>
                      <div class="col-md-12 mb-2" style="background-color: #cccccc1f;" v-bind:class="{ 'disabled-div': dis_class }" v-for="(column, index) in tskills.slice(3, 5)" :key="index">
                        <h5><strong>{{column.skill_name}}</strong></h5>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td style="width: 30%"><label>Rating</label></td>
                              <td>
                                <star-rating :read-only="true" :show-rating="false" active-color="#5bad2b" v-model.lazy.trim="column.skill_rating" v-bind:star-size="20" ></star-rating>
                              </td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Experience</label>
                              </td>
                              <td>{{column.experience}}</td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Technical Concepts</label>
                              </td>
                              <td style="overflow-wrap: anywhere;">{{column.program_concept}}</td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Logic</label>
                              </td>
                              <td style="overflow-wrap: anywhere;">{{column.logics}}</td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Development Tools</label>
                              </td>
                              <td style="overflow-wrap: anywhere;">{{column.development_tools}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </section>
                    </div>
                    <div v-if="showcomplete">
                    <div v-if="tskillsLength > 5" class="html2pdf__page-break"/>
                    <section class="row pdf-item" v-if="tskillsLength > 5">
                      <div style="height: 100px;"><p></p></div>
                      <div class="col-md-12 mb-2" style="background-color: #cccccc1f;" v-bind:class="{ 'disabled-div': dis_class }" v-for="(column, index) in tskills.slice(5, 7)" :key="index">
                        <h5><strong>{{column.skill_name}}</strong></h5>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td style="width: 30%"><label>Rating</label></td>
                              <td>
                                <star-rating :read-only="true" :show-rating="false" active-color="#5bad2b" v-model.lazy.trim="column.skill_rating" v-bind:star-size="20" ></star-rating>
                              </td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Experience</label>
                              </td>
                              <td>{{column.experience}}</td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Technical Concepts</label>
                              </td>
                              <td style="overflow-wrap: anywhere;">{{column.program_concept}}</td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Logic</label>
                              </td>
                              <td style="overflow-wrap: anywhere;">{{column.logics}}</td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Development Tools</label>
                              </td>
                              <td style="overflow-wrap: anywhere;">{{column.development_tools}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </section>
                    </div>
                    <div v-if="showcomplete">
                    <div v-if="tskillsLength > 7" class="html2pdf__page-break"/>
                    <section class="row pdf-item" v-if="tskillsLength > 7">
                      <div style="height: 100px;"><p></p></div>
                      <div class="col-md-12 mb-2" style="background-color: #cccccc1f;" v-bind:class="{ 'disabled-div': dis_class }" v-for="(column, index) in tskills.slice(7, 9)" :key="index">
                        <h5><strong>{{column.skill_name}}</strong></h5>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td style="width: 30%"><label>Rating</label></td>
                              <td>
                                <star-rating :read-only="true" :show-rating="false" active-color="#5bad2b" v-model.lazy.trim="column.skill_rating" v-bind:star-size="20" ></star-rating>
                              </td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Experience</label>
                              </td>
                              <td>{{column.experience}}</td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Technical Concepts</label>
                              </td>
                              <td style="overflow-wrap: anywhere;">{{column.program_concept}}</td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Logic</label>
                              </td>
                              <td style="overflow-wrap: anywhere;">{{column.logics}}</td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Development Tools</label>
                              </td>
                              <td style="overflow-wrap: anywhere;">{{column.development_tools}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </section>
                    </div>
                    <div v-if="showcomplete">
                    <div v-if="tskillsLength > 9" class="html2pdf__page-break"/>
                    <section class="row pdf-item" v-if="tskillsLength > 9">
                      <div style="height: 100px;"><p></p></div>
                      <div class="col-md-12 mb-2" style="background-color: #cccccc1f;" v-bind:class="{ 'disabled-div': dis_class }" v-for="(column, index) in tskills.slice(9, 11)" :key="index">
                        <h5><strong>{{column.skill_name}}</strong></h5>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td style="width: 30%"><label>Rating</label></td>
                              <td>
                                <star-rating :read-only="true" :show-rating="false" active-color="#5bad2b" v-model.lazy.trim="column.skill_rating" v-bind:star-size="20" ></star-rating>
                              </td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Experience</label>
                              </td>
                              <td>{{column.experience}}</td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Technical Concepts</label>
                              </td>
                              <td style="overflow-wrap: anywhere;">{{column.program_concept}}</td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Logic</label>
                              </td>
                              <td style="overflow-wrap: anywhere;">{{column.logics}}</td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Development Tools</label>
                              </td>
                              <td style="overflow-wrap: anywhere;">{{column.development_tools}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </section>
                    </div>
                    <div v-if="showcomplete">
                    <div v-if="tskillsLength > 11" class="html2pdf__page-break"/>
                    <section class="row pdf-item" v-if="tskillsLength > 11">
                      <div style="height: 100px;"><p></p></div>
                      <div class="col-md-12 mb-2" style="background-color: #cccccc1f;" v-bind:class="{ 'disabled-div': dis_class }" v-for="(column, index) in tskills.slice(11, 12)" :key="index">
                        <h5><strong>{{column.skill_name}}</strong></h5>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td style="width: 30%"><label>Rating</label></td>
                              <td>
                                <star-rating :read-only="true" :show-rating="false" active-color="#5bad2b" v-model.lazy.trim="column.skill_rating" v-bind:star-size="20" ></star-rating>
                              </td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Experience</label>
                              </td>
                              <td>{{column.experience}}</td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Technical Concepts</label>
                              </td>
                              <td style="overflow-wrap: anywhere;">{{column.program_concept}}</td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Logic</label>
                              </td>
                              <td style="overflow-wrap: anywhere;">{{column.logics}}</td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Development Tools</label>
                              </td>
                              <td style="overflow-wrap: anywhere;">{{column.development_tools}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </section>
                    </div>
                    <div v-if="showcomplete">
                    <div class="html2pdf__page-break"/>
                    <!-- <div v-if="tskillsLength === 3 || tskillsLength === 5 || tskillsLength === 7 || tskillsLength === 9 || tskillsLength === 11" class="html2pdf__page-break"/> -->
                    <section class="row pdf-item" v-if="tskillsLength === 2">
                      <div style="height: 60px;"><p></p></div>
                      <div class="col-md-12 mb-2" style="background-color: #cccccc1f;" v-bind:class="{ 'disabled-div': dis_class }" v-for="(column, index) in tskills.slice(1, 2)" :key="index">
                        <h5><strong>{{column.skill_name}}</strong></h5>
                        <table class="table">
                          <tbody>
                            <tr>
                              <td style="width: 30%"><label>Rating</label></td>
                              <td>
                                <star-rating :read-only="true" :show-rating="false" active-color="#5bad2b" v-model.lazy.trim="column.skill_rating" v-bind:star-size="20" ></star-rating>
                              </td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Experience</label>
                              </td>
                              <td>{{column.experience}}</td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Technical Concepts</label>
                              </td>
                              <td style="overflow-wrap: anywhere;">{{column.program_concept}}</td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Logic</label>
                              </td>
                              <td style="overflow-wrap: anywhere;">{{column.logics}}</td>
                            </tr>
                            <tr>
                              <td style="width: 30%">
                                <label>Development Tools</label>
                              </td>
                              <td style="overflow-wrap: anywhere;">{{column.development_tools}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </section>
                    </div>
                    <div v-if="showcomplete">
                    <div class="col-md-12" v-bind:class="{ 'disabled-div': dis_class }">
                      <div v-if="tskillsLength !== 2" style="height: 60px;"><p></p></div>
                      <!-- <div v-if="tskillsLength === 2" style="height: 5px;"><p></p></div> -->
                      <table class="table table-bordered mb-2">
                        <thead>
                          <tr>
                            <th>Non-Technical Evaluation</th>
                            <th>Rating</th>
                            <!-- <th>Comments</th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Communication Level</td>
                            <td><star-rating :read-only="true" v-model="commun_rating" @rating-selected="setRating($event, 'commun_rating')" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                            <!-- <td><b-form-textarea  v-model.lazy.trim="$v.form.commun_comments.$model" :state="chkState('commun_comments')" class="textarea" rows="1" placeholder="Enter comments"></b-form-textarea>
                            <div v-if="this.commun_error">
                                <p v-if="!$v.form.commun_comments.required" class="login-alert-msg error-content">* Enter Comments</p>
                              </div></td> -->
                          </tr>
                          <tr>
                            <td>Attention to Details</td>
                            <td><star-rating :read-only="true" v-model="attention_rating" @rating-selected="setRating($event, 'attention_rating')" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                            <!-- <td><b-form-textarea v-model.lazy.trim="$v.form.attention_comments.$model" :state="chkState('attention_comments')" class="textarea" rows="1" placeholder="Enter comments"></b-form-textarea>
                            <div v-if="this.attention_error">
                                <p v-if="!$v.form.attention_comments.required" class="login-alert-msg error-content">* Enter Comments</p>
                              </div></td> -->
                          </tr>
                          <tr>
                            <td>Integrity</td>
                            <td><star-rating :read-only="true" v-model="integrity_rating" @rating-selected="setRating($event, 'integrity_rating')" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                            <!-- <td><b-form-textarea  v-model.lazy.trim="$v.form.integrity_comments.$model" :state="chkState('integrity_comments')" class="textarea" rows="1" placeholder="Enter comments"></b-form-textarea>
                            <div v-if="this.integrity_error">
                              <p v-if="!$v.form.integrity_comments.required" class="login-alert-msg error-content">* Enter Comments</p>
                            </div></td> -->
                          </tr>
                          <tr>
                            <td>Cooperation</td>
                            <td><star-rating :read-only="true" v-model="cooperation_rating" @rating-selected="setRating($event, 'cooperation_rating')" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                            <!-- <td><b-form-textarea  v-model.lazy.trim="$v.form.cooperation_comments.$model" :state="chkState('cooperation_comments')" class="textarea" rows="1" placeholder="Enter comments"></b-form-textarea>
                            <div v-if="this.cooperation_error">
                              <p v-if="!$v.form.cooperation_comments.required" class="login-alert-msg error-content">* Enter Comments</p>
                            </div></td> -->
                          </tr>
                          <tr>
                            <td>Stress Tolerance</td>
                            <td><star-rating :read-only="true" v-model="stress_rating" @rating-selected="setRating($event, 'stress_rating')" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                            <!-- <td><b-form-textarea  v-model.lazy.trim="$v.form.stress_comments.$model" :state="chkState('stress_comments')" class="textarea" rows="1" placeholder="Enter comments"></b-form-textarea>
                            <div v-if="this.stress_error">
                              <p v-if="!$v.form.stress_comments.required" class="login-alert-msg error-content">* Enter Comments</p>
                            </div></td> -->
                          </tr>
                          <tr>
                            <td>Learning Ability</td>
                            <td><star-rating :read-only="true" v-model="learning_rating" @rating-selected="setRating($event, 'learning_rating')" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                            <!-- <td><b-form-textarea  v-model.lazy.trim="$v.form.learning_comments.$model" :state="chkState('learning_comments')" class="textarea" rows="1" placeholder="Enter comments"></b-form-textarea>
                            <div v-if="this.learning_error">
                              <p v-if="!$v.form.learning_comments.required" class="login-alert-msg error-content">* Enter Comments</p>
                            </div></td> -->
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-md-12" v-bind:class="{ 'disabled-div': dis_class }">
                      <u><b>Others</b></u>
                      <table class="table table-bordered">
                        <tbody>
                          <tr>
                            <td>Window Violation - <b><span v-if="window_violation">Yes</span><span v-if="!window_violation">No</span></b></td>
                            <td><p>{{$v.form.window_violation_comments.$model}}</p></td>
                          </tr>
                          <tr>
                            <td><b>Final Recommendation</b></td>
                            <td></td>
                          </tr>
                          <!-- <tr>
                            <td><div class="form-group">
                            <u><b>Recommended?</b></u>
                            <p>&nbsp;</p>
                            <label class="container" style="width: 10% !important;padding-right: 40px;display: inline-block;"> Yes<input :checked="recommendedVal == 'Yes'" type="radio" name="recommended" @change="onChangerecommended('Yes')" value="Yes" style="width: 10%;">
                          <span class="checkmark"></span>
                          </label>
                            <label class="container" style="width: 10% !important;display: inline-block;">No<input :checked="recommendedVal == 'No'" type="radio" name="recommended" @change="onChangerecommended('No')" value="No" style="width: 10%;">
                            <span class="checkmark"></span>
                            </label>
                          </div></td>
                          </tr> -->
                          <tr>
                            <td>Interviewer Comments:</td>
                            <td><p>{{$v.form.interviewer_comments.$model}}</p>
                            <div v-if="this.clientError">
                                <p v-if="!$v.form.interviewer_comments.required" class="login-alert-msg error-content">* Enter Comments</p>
                              </div></td>
                          </tr>
                          <tr>
                            <td>Screenit Score</td>
                            <td><span v-for="item in 10" :key="item" v-bind:class="{'sit-score-active': item == sit_score || item < sit_score}" class="sit-score">{{item}}</span>
                            <div v-if="this.clientError">
                                <p v-if="!$v.form.screenit_score.required" class="login-alert-msg error-content">* Enter Comments</p>
                              </div></td>
                          </tr>
                          <tr>
                            <td>Recommended</td>
                            <td>{{recommended}}</td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="col-md-12" style="padding: 15px" v-if="schedule_codes.length > 0">
                      <div class="form-row" style="background-color: #cccccc69;padding: 7px;">
                        <label>Candidate's Programming Code</label>
                      </div>
                    </div>
                    <div class="col-md-12" style="padding: 16px" v-for="v in schedule_codes" :key="v">
                      <div class="form-row">
                        <label>Tittle: {{v.title}}</label>
                      </div>
                      <div class="form-row">
                         <VueCodeEditor
                          :value="v.code"
                          @init="editorInit"
                          lang="javascript"
                          theme="monokai"
                          width="100%"
                          height="200px"
                          :options="{
                            enableBasicAutocompletion: true,
                            enableLiveAutocompletion: true,
                            fontSize: 14,
                            highlightActiveLine: true,
                            enableSnippets: true,
                            showLineNumbers: true,
                            tabSize: 2,
                            showPrintMargin: true,
                            showGutter: true,
                          }"
                          :commands="[
                              {
                                name: 'save',
                                bindKey: { win: 'Ctrl-s', mac: 'Command-s' },
                                exec: null,
                                readOnly: true,
                              },
                          ]"
                          />
                      </div>
                    </div>
                    </div>
                    </div>
                    </div>
                    <div v-if="interview_type=='HR'">
                      <div v-if="showcomplete">
                        <div class="col-md-12 mb-2" style="background-color: #cccccc1f;" v-bind:class="{ 'disabled-div': dis_class }">
                          <table class="table table-bordered">
                            <thead>
                              <tr>
                                <th>Question</th>
                                <th>Rating Scale</th>
                                <th>Comments</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <div class="justify-td">
                                    <span>Did the candidate have the necessary qualifications and experience for the role?</span>
                                    <span >
                                      <i id="popover-target-1" style="color:#1163e6; text-shadow: 0px 2px 3px #a39f9f; font-size: 16px;" class="fa fa-question-circle" aria-hidden="true"></i>
                                      <b-popover target="popover-target-1" triggers="hover" placement="top">
                                        <div style="padding: 10px">
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Education and certifications</div>
                                          <div style="color:grey; font-size: 12px;">This metric evaluates the candidate's educational background and professional certifications. It can help you determine if they have the necessary academic qualifications for the role.</div>
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Work experience</div>
                                          <div style="color:grey; font-size: 12px;">This metric assesses the candidate's previous work experience, including the number of years they have worked in a similar role, the level of responsibility they have held, and the industries they have worked in. This can help you determine if they have the relevant experience to perform well in the role</div>
                                        </div>
                                      </b-popover>
                                    </span>
                                  </div>
                                </td>
                                <td><star-rating v-model="qualification" :read-only="true" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                                <td>
                                  {{qualification_cmd}}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div class="justify-td">
                                    <span>How well did the candidate demonstrate their problem solving skills and abilities during the interview?</span>
                                    <span >
                                      <i id="popover-target-2" style="color:#1163e6; text-shadow: 0px 2px 3px #a39f9f; font-size: 16px;" class="fa fa-question-circle" aria-hidden="true"></i>
                                      <b-popover target="popover-target-2" triggers="hover" placement="top">
                                        <div style="padding: 10px">
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Approach to problem-solving</div>
                                          <div style="color:grey; font-size: 12px;">This metric evaluates the candidate's approach to solving a problem. It can help you determine if they can break down complex problems into smaller parts and approach them systematically</div>
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Creativity and innovation</div>
                                          <div style="color:grey; font-size: 12px;">This metric evaluates the candidate's ability to come up with creative and innovative solutions to problems. It can help you determine if they can think outside the box and come up with new and unique ideas</div>
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Decision-making</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who can make effective decisions under pressure demonstrate good decision-making skills</div>
                                        </div>
                                      </b-popover>
                                    </span>
                                  </div>
                                </td>
                                <td><star-rating v-model="problem_solving" :read-only="true" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                                <td>
                                  {{problem_solving_cmd}}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div class="justify-td">
                                    <span>How well the candidate exhibit professionalism?</span>
                                    <span >
                                      <i id="popover-target-3" style="color:#1163e6; text-shadow: 0px 2px 3px #a39f9f; font-size: 16px;" class="fa fa-question-circle" aria-hidden="true"></i>
                                      <b-popover target="popover-target-3" triggers="hover" placement="top">
                                        <div style="padding: 10px">
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Appearance</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who present themselves in a professional and appropriate manner, including their dress, grooming, and body language, demonstrate professionalism. This metric can help you assess the candidate's attention to detail and their ability to represent the company well.</div>
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Punctuality and reliability</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who arrive on time for the interview, respond promptly to emails and calls, and follow through on commitments demonstrate punctuality and reliability. This metric can help you assess the candidate's dependability and work ethic.</div>
                                        </div>
                                      </b-popover>
                                    </span>
                                  </div>
                                </td>
                                <td><star-rating v-model="professionalism" :read-only="true" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                                <td>
                                  {{professionalism_cmd}}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div class="justify-td">
                                    <span>Did the candidate exhibit a positive attitude and confidence throughout the interview?</span>
                                    <span >
                                      <i id="popover-target-4" style="color:#1163e6; text-shadow: 0px 2px 3px #a39f9f; font-size: 16px;" class="fa fa-question-circle" aria-hidden="true"></i>
                                      <b-popover target="popover-target-4" triggers="hover" placement="top">
                                        <div style="padding: 10px">
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Enthusiasm</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who display enthusiasm and excitement about the role and the company demonstrate a positive attitude. This metric can help you assess the candidate's level of interest and engagement in the position.</div>
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Confidence</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who display confidence in their abilities, experience, and responses demonstrate confidence. This metric can help you assess the candidate's self-assurance and assertiveness.</div>
                                        </div>
                                      </b-popover>
                                    </span>
                                  </div>
                                </td>
                                <td><star-rating v-model="attitude_confidence" :read-only="true" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                                <td>
                                  {{ attitude_confidence_cmd }}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div class="justify-td">
                                    <span>How well did the candidate demonstrate their communication skills ?</span>
                                    <span >
                                      <i id="popover-target-5" style="color:#1163e6; text-shadow: 0px 2px 3px #a39f9f; font-size: 16px;" class="fa fa-question-circle" aria-hidden="true"></i>
                                      <b-popover target="popover-target-5" triggers="hover" placement="top">
                                        <div style="padding: 10px">
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Clarity</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who communicate clearly and concisely, using appropriate language and tone, demonstrate good communication skills. This metric can help you assess the candidate's ability to convey information effectively.</div>
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Nonverbal communication</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who use appropriate nonverbal cues, including eye contact, facial expressions, and body language, demonstrate good communication skills. This metric can help you assess the candidate's ability to communicate effectively and build rapport with others.</div>
                                        </div>
                                      </b-popover>
                                    </span>
                                  </div>
                                </td>
                                <td><star-rating v-model="communication_skill" :read-only="true" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                                <td>
                                  {{ communication_skill_cmd }}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div class="justify-td">
                                    <span>How well did the candidate demonstrate their interpersonal skills ?</span>
                                    <span >
                                      <i id="popover-target-6" style="color:#1163e6; text-shadow: 0px 2px 3px #a39f9f; font-size: 16px;" class="fa fa-question-circle" aria-hidden="true"></i>
                                      <b-popover target="popover-target-6" triggers="hover" placement="top">
                                        <div style="padding: 10px">
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Empathy</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who demonstrate empathy, including the ability to understand and share the feelings of others, demonstrate good interpersonal skills. This metric can help you assess the candidate's ability to relate to and connect with team members, customers, and stakeholders.</div>
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Conflict resolution</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who demonstrate the ability to resolve conflicts and disagreements constructively and diplomatically demonstrate good interpersonal skills. This metric can help you assess the candidate's ability to handle challenging situations and work effectively with others.</div>
                                        </div>
                                      </b-popover>
                                    </span>
                                  </div>
                                </td>
                                <td><star-rating v-model="inter_personal_skill" :read-only="true" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                                <td>
                                  {{inter_personal_skill}}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div class="justify-td">
                                    <span>Did the candidate express interest in potential opportunities for growth and development within the company?</span>
                                    <span >
                                      <i id="popover-target-7" style="color:#1163e6; text-shadow: 0px 2px 3px #a39f9f; font-size: 16px;" class="fa fa-question-circle" aria-hidden="true"></i>
                                      <b-popover target="popover-target-7" triggers="hover" placement="top">
                                        <div style="padding: 10px">
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Career goals</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who express clear career goals and aspirations, and who demonstrate a desire to grow and develop within the company, demonstrate an interest in potential opportunities for growth and development. This metric can help you assess the candidate's level of ambition and motivation.</div>
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Job satisfaction</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who express satisfaction with the job and the company, and who indicate a desire to grow and develop within their role, demonstrate an interest in potential opportunities for growth and development. This metric can help you assess the candidate's level of engagement and motivation.</div>
                                        </div>
                                      </b-popover>
                                    </span>
                                  </div>
                                </td>
                                <td><star-rating v-model="growth_development" :read-only="true" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                                <td>
                                  {{growth_development_cmd}}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div class="justify-td">
                                    <span>How well did the candidate answer team work related Questions?</span>
                                    <span >
                                      <i id="popover-target-8" style="color:#1163e6; text-shadow: 0px 2px 3px #a39f9f; font-size: 16px;" class="fa fa-question-circle" aria-hidden="true"></i>
                                      <b-popover target="popover-target-8" triggers="hover" placement="top">
                                        <div style="padding: 10px">
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Collaboration</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who demonstrate an understanding of the importance of collaboration in achieving team goals, and who provide examples of successful collaboration experiences, demonstrate good teamwork skills. This metric can help you assess the candidate's ability to work effectively with others.</div>
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Adaptability</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who demonstrate an ability to adapt to changing circumstances within a team, and who provide examples of how they have successfully navigated such changes, demonstrate good teamwork skills. This metric can help you assess the candidate's ability to work effectively in a dynamic team environment.</div>
                                        </div>
                                      </b-popover>
                                    </span>
                                  </div>
                                </td>
                                <td><star-rating v-model="team_work" :read-only="true" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                                <td>
                                  {{team_work_cmd}}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div class="justify-td">
                                    <span>How was the candidate’s responsiveness to change, and tolerance?</span>
                                    <span >
                                      <i id="popover-target-9" style="color:#1163e6; text-shadow: 0px 2px 3px #a39f9f; font-size: 16px;" class="fa fa-question-circle" aria-hidden="true"></i>
                                      <b-popover target="popover-target-9" triggers="hover" placement="top">
                                        <div style="padding: 10px">
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Tolerance for ambiguity</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who demonstrate a willingness to work in situations with unclear or uncertain outcomes, and who provide examples of how they have successfully managed ambiguity in their previous roles, demonstrate good tolerance for ambiguity. This metric can help you assess the candidate's ability to work effectively in complex and uncertain environments.</div>
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Flexibility</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who demonstrate an ability to be flexible and to adjust their approach or methods as needed, and who provide examples of how they have successfully done so in their previous roles, demonstrate good responsiveness to change. This metric can help you assess the candidate's ability to work effectively in a fast-paced and changing work environment.</div>
                                        </div>
                                      </b-popover>
                                    </span>
                                  </div>
                                </td>
                                <td><star-rating v-model="stress_tolerance" :read-only="true" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                                <td>
                                  {{stress_tolerance_cmd}}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div class="justify-td">
                                    <span>How potential is the candidate to fit the Organization’s culture?</span>
                                    <span >
                                      <i id="popover-target-10" style="color:#1163e6; text-shadow: 0px 2px 3px #a39f9f; font-size: 16px;" class="fa fa-question-circle" aria-hidden="true"></i>
                                      <b-popover target="popover-target-10" triggers="hover" placement="top">
                                        <div style="padding: 10px">
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Values Alignment</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who demonstrate an understanding of the organization's values and mission, and who share those values, are more likely to fit well within the organization's culture. This metric can help you assess the candidate's values and their potential to align with the organization's culture.</div>
                                          <div style="color:black; font-size: 14px; font-weight:bold;">Cultural Fit</div>
                                          <div style="color:grey; font-size: 12px;">Candidates who demonstrate an understanding of the organization's culture and who can provide examples of how they have successfully adapted to a similar culture in the past, are more likely to fit well within the organization's culture. This metric can help you assess the candidate's ability to work effectively within the organization's culture.</div>
                                        </div>
                                      </b-popover>
                                    </span>
                                  </div>
                                </td>
                                <td><star-rating v-model="org_culture" :read-only="true" :show-rating="false" active-color="#5bad2b" v-bind:star-size="20"></star-rating></td>
                                <td>
                                  {{org_culture_cmd}}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="col-md-12" v-bind:class="{ 'disabled-div': dis_class }">
                          <u><b>Others</b></u>
                          <table class="table table-bordered mt-2">
                            <tbody>
                              <tr>
                                <td>Window Violation - <b><span v-if="window_violation">Yes</span><span v-if="!window_violation">No</span></b></td>
                                <td  class="sitscclass">
                                  <b-form-textarea  disabled v-model.lazy.trim="$v.form.window_violation_comments.$model" :state="chkState('window_violation')" class="textarea" rows="1" placeholder="Enter comments">
                                  </b-form-textarea>
                                  <div v-if="this.clientError">
                                    <p v-if="!$v.form.window_violation.required" class="login-alert-msg error-content">* Enter Comments</p>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td><b>Final Recommendation</b></td>
                                <td  class="sitscclass"></td>
                              </tr>
                              <tr>
                                <td>Interviewer Comments:</td>
                                <td  class="sitscclass">
                                  <b-form-textarea disabled v-model.lazy.trim="$v.form.interviewer_comments.$model" :state="chkState('interviewer_comments')" class="textarea" rows="1" placeholder="Enter comments"></b-form-textarea>
                                  <div v-if="this.clientError">
                                    <p v-if="!$v.form.interviewer_comments.required" class="login-alert-msg error-content">* Enter Comments</p>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>Screenit Score</td>
                                <td  class="sitscclass">
                                  <div>
                                    <span v-for="item in 10" :key="item" v-bind:class="{'sit-score-active': item == sit_score || item < sit_score}" class="sit-score">{{item}}</span>
                                  </div>
                                  <div v-if="this.clientError">
                                    <p v-if="!$v.form.screenit_score.required" class="login-alert-msg error-content">* Enter Comments</p>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>Recommended</td>
                                <td  class="sitscclass">{{recommended}}</td>
                              </tr>
                            </tbody>
                          </table>
                          <div class="box-body" id="html-template">
                            <!-- start tab -->
                            <div class="col-md-6" v-if="view!='web'">
                              <!-- <p class="text-muted" style="text-align: center;">Rate this Interview</p> -->
                              <!-- :width="900" :height="450" -->
                              <hls-player :height="200" :autoplay="false" :muted="true" :controls="true" ref="myPlayer" :source="schedulevideo"/>
                            </div>
                            <div class="col-md-12" v-if="view=='web'">
                              <!-- <p class="text-muted" style="text-align: center;">Rate this Interview</p> -->
                              <!-- :width="900" :height="450" -->
                              <hls-player :height="450" :autoplay="false" :muted="true" :controls="true" ref="myPlayer" :source="schedulevideo"/>
                            </div>
                          </div>
                          <div class="col-md-12" style="padding: 15px" v-if="schedule_codes.length > 0">
                            <div class="form-row" style="background-color: #cccccc69;padding: 7px;">
                              <label>Candidate's Programming Code</label>
                            </div>
                          </div>
                          <div class="col-md-12" style="padding: 16px" v-for="v in schedule_codes" :key="v">
                            <div class="form-row">
                              <label>Tittle: {{v.title}}</label>
                            </div>
                            <div class="form-row">
                              <VueCodeEditor
                                :value="v.code"
                                @init="editorInit"
                                lang="javascript"
                                theme="monokai"
                                width="100%"
                                height="200px"
                                :options="{
                                  enableBasicAutocompletion: true,
                                  enableLiveAutocompletion: true,
                                  fontSize: 14,
                                  highlightActiveLine: true,
                                  enableSnippets: true,
                                  showLineNumbers: true,
                                  tabSize: 2,
                                  showPrintMargin: true,
                                  showGutter: true,
                                }"
                                :commands="[
                                    {
                                      name: 'save',
                                      bindKey: { win: 'Ctrl-s', mac: 'Command-s' },
                                      exec: null,
                                      readOnly: true,
                                    },
                                ]"
                                />
                            </div>
                          </div>
                        </div>
                        <br>
                        <br>
                      </div>
                    </div>
              </div>
            </div>
        </section>
        </vue-html2pdf>
  </section>
</template>

<script>
import axios from 'axios'
import { BaseURLV3 } from '../shared/classes'
import * as Cookies from 'js-cookie'
import router from '../router/index'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import Vue from 'vue'
import StarRating from 'vue-star-rating'
// import { ToggleButton } from 'vue-js-toggle-button'
import VueCodeEditor from 'vue2-code-editor'
import 'vue-loading-overlay/dist/vue-loading.css'
import html2pdf from 'html2pdf.js'
import $ from 'jquery'
import VueHtml2pdf from 'vue-html2pdf'
// import { Carousel, Slide } from 'vue-carousel'
import momentsone from 'moment-timezone'
import 'hls-player/dist/hls-player.css'
import hlsPlayer from 'hls-player'

import moment from 'moment'
Vue.use(moment)
const formShape = {
  interview: '',
  commun_comments: '',
  attention_comments: '',
  integrity_comments: '',
  cooperation_comments: '',
  stress_comments: '',
  learning_comments: '',
  commun_rating: '',
  attention_rating: '',
  integrity_rating: '',
  cooperation_rating: '',
  stress_rating: '',
  learning_rating: '',
  recommended_for: '',
  other_comments: '',
  TDD_code: '',
  proxy: 'No',
  recommended: 'Yes',
  candidate_no_show: 'No',
  interview_status: 'Completed',
  screenit_score: '',
  interviewer_comments: '',
  window_violation: false,
  window_violation_comments: ''
}
const formShape2 = {
  comments: '',
  comments2: '',
  comments3: '',
  comments4: ''
}
const formShape3 = {
  remarks: '',
  remarks2: '',
  remarks3: '',
  remarks4: '',
  remarks5: ''
}
export default {
  name: 'addFeedback',
  data () {
    return {
      form: Object.assign({}, formShape),
      form2: Object.assign({}, formShape2),
      form3: Object.assign({}, formShape3),
      picked: 'Speaks with limited fluency, irregular grammar and carries a distinct accent',
      files: [],
      Files: [],
      window_violation: false,
      clientError: false,
      commun_error: false,
      attention_error: false,
      integrity_error: false,
      cooperation_error: false,
      stress_error: false,
      learning_error: false,
      tskills: [],
      tskillsLength: 0,
      manskills: [],
      postSkills: [],
      pfskills: [],
      rolelist: '',
      dis_class: false,
      pdfdocumentshow: false,
      schedule_codes: '',
      fid: '',
      sit_score: 0,
      sid: Cookies.get('sid'),
      feedbackis: false,
      isLoading: true,
      comm_level_rating: 0,
      feedbackLength: 0,
      scheduleDetails: [],
      postDetails: [],
      feedbackDetail: [],
      schedule_id: '',
      mode_error: false,
      showincomplete: false,
      showcomplete: true,
      proxyVal: 'No',
      recommendedVal: 'No',
      candidateshow: 'No',
      recommended: '',
      post_id: '',
      resume: [],
      config: {
        headers: {
          'content-type': 'application/json'
          // Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      interview_status_error: false,
      feedbacknotdone: true,
      feedbackdone: false,
      reasonList: [],
      reason: '',
      reason_comment: '',
      reason_comment_required: false,
      reason_required: false,
      commun_rating: 0,
      attention_rating: 0,
      integrity_rating: 0,
      cooperation_rating: 0,
      stress_rating: 0,
      learning_rating: 0,
      timezone: momentsone.tz.guess(),
      vOption: {},
      schedulevideo: '',
      view: 'web',
      interview_type: 'Tech',
      qualification: 0,
      qualification_cmd: '',
      problem_solving: 0,
      problem_solving_cmd: '',
      professionalism: 0,
      professionalism_cmd: '',
      attitude_confidence: 0,
      attitude_confidence_cmd: '',
      communication_skill: 0,
      communication_skill_cmd: '',
      inter_personal_skill: 0,
      inter_personal_skill_cmd: '',
      growth_development: 0,
      growth_development_cmd: '',
      team_work: 0,
      team_work_cmd: '',
      stress_tolerance: 0,
      stress_tolerance_cmd: '',
      org_culture: 0,
      org_culture_cmd: '',
      interviewChats: [],
      canName: '',
      intName: '',
      orgName: ''
    //   techskillta:[
    //    {
    //   textarea1: '',
    //    }
    //  ],
    //  manskillta:[
    //    {
    //   textarea: '',
    //    }
    //  ]
    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    },
    isDirty () {
      return this.$v.form.$anyDirty
    },
    invCheck () {
      return 'You must accept before submitting'
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      interview: {
        required
      },
      commun_comments: {},
      attention_comments: {},
      integrity_comments: {},
      cooperation_comments: {},
      stress_comments: {},
      learning_comments: {},
      commun_rating: {},
      attention_rating: {},
      integrity_rating: {},
      cooperation_rating: {},
      stress_rating: {},
      learning_rating: {},
      recommended_for: {
        // required
      },
      screenit_score: {},
      interviewer_comments: {
        // required
      },
      proxy: {},
      recommended: {},
      candidate_no_show: {},
      interview_status: {
        required
      },
      window_violation: {},
      window_violation_comments: {}
    },
    form2: {
      comments: {
        required
      },
      comments2: {
        required
      },
      comments3: {
        required
      },
      comments4: {
        required
      }
    },
    form3: {
      remarks: {
        required
      },
      remarks2: {
        required
      },
      remarks3: {
        required
      },
      remarks4: {
        required
      },
      remarks5: {
        required
      }
    }
  },
  components: {
    StarRating, VueCodeEditor, VueHtml2pdf, hlsPlayer
  },
  created () {
    this.schedule_id = this.$route.params.id
    this.view = this.$route.params.view
    this.getFeedbackDetails()
    // this.getFetchrolename()
    this.getscheduleDetails()
    this.getReasons()
  },
  methods: {
    generatePDF () {
      this.$refs.html2Pdf.generatePdf()
    },
    getDate (date) {
      return momentsone(date).utc().tz(this.timezone).format('DD MMM YYYY')
    },
    getTime (date) {
      return momentsone(date).utc().tz(this.timezone).format('hh:mm a')
    },
    getEndTime (date) {
      return momentsone(date).utc().tz(this.timezone).add(1, 'h').format('hh:mm a')
    },
    Download () {
      const element = document.getElementById('pdfdocument')
      const opt = {
        margin: 1,
        filename: 'feedback.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 3 },
        pagebreak: { before: '.newPage', after: '.after', avoid: '.avoid' },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      }
      html2pdf().from(element).set(opt).save()
    },
    changeScore (n) {
      this.sit_score = Number(n)
      if (this.sit_score < 5) {
        this.recommended = 'Rejected'
      } else if (this.sit_score < 7) {
        this.recommended = 'Near Fit'
      } else if (this.sit_score < 9) {
        this.recommended = 'Hire'
      } else if (this.sit_score > 8) {
        this.recommended = 'Strong Hire'
      }
    },
    showpreview () {
      this.pdfdocumentshow = true
    },
    closepreview () {
      this.pdfdocumentshow = false
    },
    onChangeproxy (val) {
      if (val === 'Yes') {
        this.dis_class = true
      } else {
        this.dis_class = false
      }
      this.proxyVal = val
      if (this.candidateshow === 'Yes' || this.proxyVal === 'Yes') {
        console.log('success')
        this.recommendedVal = 'No'
      }
    },
    onChangerecommended (val) {
      this.recommendedVal = val
    },
    onChangecandidate (val) {
      if (val === 'Yes') {
        this.dis_class = true
      } else {
        this.dis_class = false
      }
      this.candidateshow = val
      if (this.candidateshow === 'Yes' || this.proxyVal === 'Yes') {
        this.recommendedVal = 'No'
      }
    },
    getscheduleDetails () {
      console.log(this.$route.params.id)
      axios.get(BaseURLV3 + '/interviewer/' + this.$route.params.id + '/meeting', this.config).then(response => {
        // this.scheduleDetails = response.data.scheduleList[0]
        this.scheduleDetails = response.data.schedule
        // if (this.scheduleDetails.feedback_status === 'Pending') {
        //   this.feedbacknotdone = true
        //   this.feedbackdone = false
        // } else {
        //   this.feedbacknotdone = false
        //   this.feedbackdone = true
        // }
        if (this.scheduleDetails.enaleeditfeedback === 'no') {
          // router.push({ name: 'feedbackCompleted' })
        }
        if (this.scheduleDetails.post_id != null) {
          this.post_id = this.scheduleDetails.post_id
          this.getPostDetails(this.scheduleDetails.post_id)
        }
      }).catch(e => {
      })
    },
    getReasons () {
      axios.get(BaseURLV3 + '/interviewer/cancel_reason', this.config).then(response => {
        this.reasonList = response.data.reason
      }).catch(e => {
      })
    },
    getPostDetails (id) {
      axios.get(BaseURLV3 + '/org/post/' + id, this.config).then(response => {
        if (response.data.success) {
          this.postDetails = response.data.post
        }
        this.isLoading = false
        console.log('done')
      }).catch(e => {
      })
    },
    fileUpload (e) {
      console.log('file', e.target.files)
      this.files = e.target.files
      this.Files = e.target.files[0]
      console.log('Files', this.Files)
      $('.custom-file-upload').removeClass('is-invalid')
      for (let k = 0; k < e.target.files.length; k++) {
        if (e.target.files[k].type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || e.target.files[k].type === 'application/pdf' || e.target.files[k].type === 'application/msword') {
          if (e.target.files[k].size < '2000001') {
            this.files.push(e.target.files[k])
          }
        }
      }
      $('#file').val('')
      console.log(this.files)
      // const formData = new FormData()

      // formData.append('image', this.Files)
      // axios.post(BaseURLV3 + '/dashboard/upload_candidate_image/' + this.schedule_id,
      //   formData, this.config).then(response => {
      //   console.log(response)
      // }).catch(e => {
      //   console.log(e)
      // })
    },
    onChange (event) {
      this.picked = event.target.value
      console.log('this.picked', this.picked)
    },
    removeUploading (index) {
      this.Files = ''
      console.log(this.files)
    },
    changepass () {
      this.olderror = false
    },
    getdate (x) {
      const d = moment().add(x, 'days')
      return moment(d).format('DD MMM YYYY')
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    chkState2 (val) {
      const field = this.$v.form2[val]
      return !field.$dirty || !field.$invalid
    },
    chkState3 (val) {
      const field = this.$v.form3[val]
      return !field.$dirty || !field.$invalid
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    },
    removeElement (row) {
      const index = this.rows.indexOf(row)
      this.rows.splice(index, 1)
    },
    changecomments () {
      const len = this.$v.form2.comments.$model.length
      const c2len = this.$v.form2.comments2.$model.length
      const c3len = this.$v.form2.comments3.$model.length
      const c4len = this.$v.form2.comments4.$model.length
      console.log('len....', len)
      if (len < '1' || c2len < '1' || c3len < '1' || c4len < '1') {
        this.clientError = true
      } else {
        this.clientError = false
      }
    },
    changeremarks () {
      const remlen = this.$v.form3.remarks.$model.length
      const rem2len = this.$v.form3.remarks2.$model.length
      const rem3len = this.$v.form3.remarks3.$model.length
      const rem4len = this.$v.form3.remarks4.$model.length
      const rem5len = this.$v.form3.remarks5.$model.length
      if (remlen < '1' || rem2len < '1' || rem3len < '1' || rem4len < '1' || rem5len < '1') {
        this.clientError = true
      } else {
        this.clientError = false
      }
    },
    setRating (evt, rating) {
      if (rating === 'commun_rating') {
        console.log('done', evt)
        this.form.commun_rating = evt
      } else if (rating === 'attention_rating') {
        this.form.attention_rating = evt
      } else if (rating === 'integrity_rating') {
        this.form.integrity_rating = evt
      } else if (rating === 'cooperation_rating') {
        this.form.cooperation_rating = evt
      } else if (rating === 'stress_rating') {
        this.form.stress_rating = evt
      } else if (rating === 'learning_rating') {
        this.form.learning_rating = evt
      }
      console.log(this.form)
    },
    changeloecomments () {
      const junlen = this.$v.form.jun_level.$model.length
      const midlen = this.$v.form.mid_level.$model.length
      const senlen = this.$v.form.sen_level.$model.length
      const leadlen = this.$v.form.lead.$model.length
      const archlevel = this.$v.form.architect_level.$model.length

      if (junlen < '1' || midlen < '1' || senlen < '1' || archlevel < '1' || leadlen < '1') {
        this.clientError = true
      } else {
        this.clientError = false
      }
    },
    changecommentsrecommen () {
      const crecommenlen = this.$v.form.technical_obser.$model.length
      const crecommenlen2len = this.$v.form.anal_prosolving.$model.length
      const crecommenlen3len = this.$v.form.attitude.$model.length
      const crecommenlen4len = this.$v.form.clar_answer.$model.length
      if (crecommenlen < '1' || crecommenlen2len < '1' || crecommenlen3len < '1' || crecommenlen4len < '1') {
        this.clientError = true
      } else {
        this.clientError = false
      }
    },
    changefinalrecommen () {
      const recommendedlen = this.$v.form.recommended_for.$model.length
      const othercommentslen = this.$v.form.other_comments.$model.length
      const tddcodelen = this.$v.form.TDD_code.$model.length

      if (recommendedlen < '1' || othercommentslen < '1' || tddcodelen < '1') {
        this.clientError = true
      } else {
        this.clientError = false
      }
    },
    changentcomments () {
      const communlevelcomment = this.$v.form.commun_level_comments.$model.length
      if (communlevelcomment < '1') {
        this.clientError = true
      } else {
        this.clientError = false
      }
    },
    onchangeStatus () {
      this.interview_status_error = false
      console.log(this.form.interview_status)
      if (this.form.interview_status === 'InComplete') {
        this.showincomplete = true
        this.showcomplete = false
      } else {
        this.showincomplete = false
        this.showcomplete = true
      }
    },
    onchangereason () {
      this.reason_comment_required = false
      this.reason_required = false
    },
    onSubmitInComplete () {
      if (!this.reason) {
        this.reason_required = true
        return false
      }
      if (!this.reason_comment) {
        this.reason_comment_required = true
        return false
      }
      const data = {
        comments: 'Comments of the feedback',
        schedule_id: this.schedule_id,
        interview_status: this.form.interview_status,
        incomplete_reason_name: this.reason,
        incomplete_reason_cmt: this.reason_comment
      }
      // this.isLoading = true
      axios.post(BaseURLV3 + '/dashboard/add_feedback_incomplete_new', { formData: data }, this.config).then(response => {
        console.log(response)
        window.location.href = 'https://screenit.io'
      }).catch(e => {})
    },
    onSubmitFeedback () {
      if (this.showincomplete) {
        this.onSubmitInComplete()
        return false
      }
      console.log(this.form)
      console.log(this.tskills)
      console.log(this.pfskills)
      console.log(this.window_violation)
      this.interview_status_error = false
      if (!this.form.interview_status) {
        this.interview_status_error = true
        return false
      }
      const data = {
        comments: 'Comments of the feedback',
        schedule_id: this.schedule_id,
        stress_tolerance: this.form.stress_rating,
        communication_skill: this.form.commun_rating,
        attention: this.form.attention_rating,
        intrigity: this.form.integrity_rating,
        learning_ability: this.form.learning_rating,
        interview_status: this.form.interview_status,
        window_violation: this.window_violation,
        cooperation: this.form.cooperation_rating,
        window_violation_cmt: this.form.window_violation_comments,
        sit_score: this.sit_score,
        proxy: this.proxyVal,
        candidate_no_show: this.candidateshow
      }
      this.isLoading = true
      axios.post(BaseURLV3 + '/dashboard/add_feedback_complete_new/', { formData: data }, this.config).then(response => {
        console.log(response)
        this.addFeedbackSkills(response.data.feedback_id)
      }).catch(e => {})
    },
    addFeedbackSkills (id) {
      console.log('come')
      const mainurl = '/dashboard/add_feedback_skill'
      this.tskills.map(element => {
        element.feedback_id = id
      })
      this.pfskills.map(element => {
        element.feedback_id = id
      })
      const postdatas = this.tskills.concat(this.pfskills)
      this.isLoading = false
      console.log('done')
      axios.post(`${BaseURLV3}${mainurl}`, { formData: postdatas }, this.config).then(response => {
        console.log('add_feedback_skill_acs', response.data)
        window.location.href = 'https://screenit.io'
      }).catch(e => {
        console.log(e)
      })
    },
    upload () {
      const formData = new FormData()
      formData.append('image', this.Files)
      axios.post(BaseURLV3 + '/dashboard/upload_candidate_image/' + this.schedule_id,
        formData, this.config).then(response => {
        console.log(response)
        window.location.href = 'https://screenit.io'
      }).catch(e => {})
    },
    tspostChange (index) {
      console.log(index)
      this.postSkills[index].required = false
      console.log(this.postSkills[index])
    },
    mansChange (index) {
      console.log(index)
      this.manskills[index].required = false
      console.log(this.manskills[index])
    },
    getFetchrolename () {
      const mainurl = '/dashboard/get_role_template'
      axios.get(`${BaseURLV3}${mainurl}`, this.config).then(response => {
        console.log(response.data)
        console.log(response)
        var data = response.data.role_template_list
        console.log('rolename', data)
        this.rolelist = data[0].role_name
      }).catch(e => {
        console.log(e)
      })
    },
    getFeedbackDetails () {
      // const mainurl = '/dashboard/get_schedule_feedback_new/' + this.schedule_id
      const mainurl = '/interviewer/' + this.$route.params.id + '/feedback'
      axios.get(`${BaseURLV3}${mainurl}`, this.config).then(response => {
        if (response.data.schedule.interview_type === 'HR') {
          this.interview_type = 'HR'
        } else {
          this.interview_type = 'Tech'
        }
        this.interviewChats = response.data.schedule.chat
        this.canName = response.data.schedule.candidate.first_name
        this.intName = response.data.schedule.interviewer.candidate.first_name
        this.orgName = 'Organization'
        this.candidateName = name
        console.log('this.interviewChats ', this.interviewChats)
        this.feedbackDetail = response.data.schedule.feedback[0]
        this.resume = response.data.schedule.candidate.resume
        this.schedulevideo = response.data.schedule.video_url
        this.schedule_codes = response.data.schedule.code
        this.form.candidate_no_show = this.feedbackDetail.candidate_no_show
        this.form.proxy = this.feedbackDetail.proxy
        this.form.interview_status = this.feedbackDetail.interview_status
        this.commun_rating = this.feedbackDetail.communication_skill
        this.attention_rating = this.feedbackDetail.attention
        this.integrity_rating = this.feedbackDetail.intrigity
        this.cooperation_rating = this.feedbackDetail.co_operation
        this.stress_rating = this.feedbackDetail.stress_tolerance
        this.learning_rating = this.feedbackDetail.learning_ability

        this.qualification = this.feedbackDetail.qualification
        this.qualification_cmd = this.feedbackDetail.qualification_cmd
        this.problem_solving = this.feedbackDetail.problem_solving
        this.problem_solving_cmd = this.feedbackDetail.problem_solving_cmd
        this.professionalism = this.feedbackDetail.professionalism
        this.professionalism_cmd = this.feedbackDetail.professionalism_cmd
        this.attitude_confidence = this.feedbackDetail.attitude_confidence
        this.attitude_confidence_cmd = this.feedbackDetail.attitude_confidence_cmd
        this.communication_skill = this.feedbackDetail.communication_skill
        this.communication_skill_cmd = this.feedbackDetail.communication_skill_cmd
        this.inter_personal_skill = this.feedbackDetail.inter_personal_skill
        this.inter_personal_skill_cmd = this.feedbackDetail.inter_personal_skill_cmd
        this.growth_development = this.feedbackDetail.growth_development
        this.growth_development_cmd = this.feedbackDetail.growth_development_cmd
        this.team_work = this.feedbackDetail.team_work
        this.team_work_cmd = this.feedbackDetail.team_work_cmd
        this.stress_tolerance = this.feedbackDetail.stress_tolerance
        this.stress_tolerance_cmd = this.feedbackDetail.stress_tolerance_cmd
        this.org_culture = this.feedbackDetail.org_culture
        this.org_culture_cmd = this.feedbackDetail.org_culture_cmd

        this.candidateshow = this.feedbackDetail.candidate_no_show !== true ? 'No' : 'Yes'
        this.proxyVal = this.feedbackDetail.proxy !== true ? 'No' : 'Yes'
        if (this.candidateshow === 'Yes' || this.proxy === 'Yes') {
          this.dis_class = true
        }
        if (this.feedbackDetail.window_violation === true) {
          console.log('success')
          this.window_violation = true
          $('#clienttoggle .v-switch-input').click()
        } else {
          this.window_violation = false
        }
        console.log(this.window_violation)
        this.form.window_violation_comments = this.feedbackDetail.window_violation_cmt
        this.form.interviewer_comments = this.feedbackDetail.comments
        this.sit_score = this.feedbackDetail.sit_score
        if (this.sit_score < 5) {
          this.recommended = 'Rejected'
        } else if (this.sit_score < 7) {
          this.recommended = 'Near Fit'
        } else if (this.sit_score < 9) {
          this.recommended = 'Hire'
        } else if (this.sit_score > 8) {
          this.recommended = 'Strong Hire'
        }
        this.tskills = this.feedbackDetail.feedback_skill
        this.tskills.map(element => {
          element.schedule_id = this.$route.params.id
          element.skill_name = element.skill.name
          if (this.candidateshow === 'Yes' || this.proxy === 'Yes') {
            element.experience = ''
          }
        })
        if (this.form.interview_status !== 'Completed') {
          this.showincomplete = true
          this.showcomplete = false
          // if (this.form.candidate_no_show === 'No') {
          this.reason = this.feedbackDetail.incomplete_reason_id
          this.reason_comment = this.feedbackDetail.incomplete_reason_cmt
          if (this.feedbackDetail.candidate_no_show) {
            this.reason_comment = 'Candidate no show'
          }
          if (this.feedbackDetail.proxy) {
            this.reason_comment = 'The candidate is a proxy. Hence not evaluated'
          }
          // }
        } else {
          this.showincomplete = false
          this.showcomplete = true
        }
        this.tskillsLength = this.tskills.length

        // this.feedbackDetail = response.data.feedbackdetails
        // this.feedbackLength = response.data.feedbackdetails.length
        // this.schedule_codes = response.data.schedule_codes
        // if (response.data.feedbackdetails.length > 0) {
        //   this.feedbackDetail = this.feedbackDetail[0]
        //   this.form.candidate_no_show = this.feedbackDetail.candidate_no_show
        //   this.form.proxy = this.feedbackDetail.proxy
        //   this.form.interview_status = this.feedbackDetail.interview_status
        //   this.commun_rating = this.feedbackDetail.communication_skill
        //   this.attention_rating = this.feedbackDetail.attention
        //   this.integrity_rating = this.feedbackDetail.intrigity
        //   this.cooperation_rating = this.feedbackDetail.cooperation
        //   this.stress_rating = this.feedbackDetail.stress_tolerance
        //   this.learning_rating = this.feedbackDetail.learning_ability
        //   this.candidateshow = this.feedbackDetail.candidate_no_show
        //   this.proxyVal = this.feedbackDetail.proxy
        //   if (this.candidateshow === 'Yes' || this.proxy === 'Yes') {
        //     this.dis_class = true
        //   }
        //   if (this.feedbackDetail.window_violation === 'true') {
        //     console.log('success')
        //     this.window_violation = true
        //     $('#clienttoggle .v-switch-input').click()
        //   } else {
        //     this.window_violation = false
        //   }
        //   console.log(this.window_violation)
        //   this.form.window_violation_comments = this.feedbackDetail.window_violation_cmt
        //   this.form.interviewer_comments = this.feedbackDetail.eligible_comments
        //   this.sit_score = this.feedbackDetail.sit_score
        //   if (this.sit_score < 5) {
        //     this.recommended = 'Rejected'
        //   } else if (this.sit_score < 7) {
        //     this.recommended = 'Near Fit'
        //   } else if (this.sit_score < 9) {
        //     this.recommended = 'Hire'
        //   } else if (this.sit_score > 8) {
        //     this.recommended = 'Strong Hire'
        //   }
        //   this.tskills = response.data.feedback_skills
        //   this.tskills.map(item => {
        //     if (this.candidateshow === 'Yes' || this.proxy === 'Yes') {
        //       item.experience = ''
        //     }
        //   })
        //   if (this.form.interview_status !== 'Completed') {
        //     this.showincomplete = true
        //     this.showcomplete = false
        //     if (this.form.candidate_no_show === 'No') {
        //       this.reason = this.feedbackDetail.incomplete_reason_name
        //       this.reason_comment = this.feedbackDetail.incomplete_reason_cmt
        //     }
        //   } else {
        //     this.showincomplete = false
        //     this.showcomplete = true
        //   }
        //   this.tskillsLength = this.tskills.length
        // }
      }).catch(e => {
        console.log(e)
      })
    },
    navigation (tabs) {
      router.push({ name: tabs })
    }
    // getTime (date) {
    //   const Start = momentsone.utc(date).tz(this.timezone).format('hh:mm a')
    //   return Start
    // },
    // getDate (date) {
    //   const Start = momentsone.utc(date).tz(this.timezone).format('DD MMM yyyy')
    //   return Start
    // }
  }
}
</script>

<style scoped>

.sitscclass {
  width: 100%;
  overflow: auto;
  display: inline-flex;
}
.content1 {
  margin: 100px !important;
  width: 80%;
  overflow: auto;
}
.box {
  overflow: auto !important;
}
@media (min-width: 768px) {
  .content1 {
    margin: 100px !important;
    width: 80%;
  }
  .sitscclass {
    width: 100%;
    overflow: auto;
    display: inline-flex;
  }
}
@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  .content1 {
    margin: 10px !important;
    width: 95%;
  }
  .sitscclass {
    width: 50%;
    overflow: auto;
    display: inline-flex;
  }
}
@media only screen and (min-device-width: 481px) and (max-device-width: 768px) {
  .content1 {
    margin: 10px !important;
    width: 95%;
  }
  .sitscclass {
    width: 50%;
    overflow: auto;
    display: inline-flex;
  }
}
@media only screen and (min-device-width: 769px) and (max-device-width: 1024px) {
  .content1 {
    margin: 10px !important;
    width: 95%;
  }
  .sitscclass {
    width: 50%;
    overflow: auto;
    display: inline-flex;
  }
}

.products-list .item:hover {
  border-left: 3px solid #ffffff;
  background-color: #ffffff;
  cursor: pointer;
}
a:hover, a:active, a:focus {
  outline: none;
  text-decoration: none;
  color: #5bad2b;
}
.errorshow {
  background-color: #ff000047;
  padding: 5px;
  color: #dd4b39 !important;
}
.post li.active {
  background-color: #5bad2b !important;
  color: white !important;
  border: 0px !important;
}
.sideborder {
  border-right: 1px solid #cccccc52;
  min-height: 700px;
  height: 100%;
}
span.field-icon {
  position: absolute;
  display: inline-block;
  cursor: pointer;
  right: 2.5rem;
  top: 0.7rem;
  z-index: 2;
  margin-top: 4px;
}
.nav-stacked>li.active>a, .nav-stacked>li.active>a:hover {
    background: transparent;
    color:white;
    border-top: 0;
    border-left-color: #5bad2b ;
}
.ml-20 {
  margin-right: 20px;
}
.ml-36 {
  margin-right: 36px;
}
.p-5 {
  padding: 5px;
}
.container {
  display: block;
  position: relative;
  padding-left: 25px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #eee;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #2196F3;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.container .checkmark:after {
  top: 6px;
  left: 6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
}
.disabled-div {
  pointer-events: none;
  opacity: 0.4;
}
.sit-score {
  background-color: #f5f5f5;
  color: #333;
  padding: 10px 15px 10px 15px;
  margin-right: 5px;
}

.sit-score-active {
  background-color: #5bad2b !important;
  color: #fff !important;
  padding: 10px 15px 10px 15px;
  margin-right: 5px;
}
.download-pdf {
  float: right;
  padding: 0px;
  padding-bottom: 15px;
}
.vue-html2pdf .pdf-preview {
  position: fixed;
  width: 85% !important;
  min-width: 600px;
  height: 100% !important;
  top: 30px !important;
  z-index: 9999999;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 5px;
  box-shadow: 0 0 10px #00000048;
}
section.content-wrapper {
  margin-left: 0px !important;
  margin-top: 0px !important;
  background-color: #fff !important;
}
.invoice {
  position: relative;
  background: #fff;
  border: 1px solid #f4f4f4;
  padding: 0px !important;
  margin: 0px 0px 0px 0px !important;
}
.justify-td {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
}
.intchatbox {
  width: 100%;
  padding-top: 10px;
  padding-left: 10px;
  margin: 10px;
  background-color: white;
  border-radius: 10px;
  color: black;
}
.roleClass {
  display: flex;
  justify-content: flex-end;
}
.roleClassIn {
  border-radius: 10px 0px 0px 0px;
  border: 1px solid rgb(199, 199, 199);
  color: white;
  padding: 3px;
  font-size: 12px;
  font-weight: bold;
}
</style>
